<template>
  <div id="IntelligentPrediction">
    <p class="view-title">智能应用</p>
    <div class="organize">
      <organize @setOrId="setOrId(arguments)" recoveryName='' @setTree="setTree"></organize>
    </div>
    <div class="list-box" style="top: 77px;">
      <header class="tabs-box clearfix">
        <div :class="{ 'active': state == 2 }" @click="headClick(2)" id="headClick0"><span>模型管理</span></div>
        <div :class="{ 'active': state == 3 }" @click="headClick(3)" id="headClick1"><span>训练任务</span></div>
      </header>
      <div class="bg t-0">
        <div class="list-top clearfix">
          <el-button type="primary" class="add-btn" @click="addModel2" id="addUserBtn"
            v-show="state == 2">新建模型</el-button>
          <!-- <div class="search-btn">
                  <el-button type="primary" class="add-btn" @click="search" id="searchBtn">搜索</el-button>
              </div>
              <div class="search">
                  <el-input
                      placeholder="请输入账号或姓名"
                      v-model="searchVal" class="search-input" id="searchUserVal" @keyup.enter.native="search">
                      <i slot="suffix" class="el-input__icon el-icon-search"></i>
                  </el-input>
              </div> -->
        </div>
        <div class="company-list clearfix" v-show="state == 2">
          <ul class="list-title">
            <li style="margin-left: 2%;">模型名称</li>
            <li class="w-18">所属企业</li>
            <li class="w-90 min-60">训练状态</li>
            <li class="w-18">训练开始时间</li>
            <!-- <li class="w-18">训练完成时间</li> -->
            <li class="w-90 min-44">训练时间</li>
            <li class="w-90 min-60">应用状态</li>
            <li class="w-90 min-60">应用时间</li>
            <li class="w-90 min-60">运行状态</li>
            <li class="w-90 min-44">平均误差</li>
            <li class="w-26 min-140">操作</li>
          </ul>
          <div class="scroll">
            <ul class="list-details" v-for="(item, i) in dataList" :key="i" v-show="dataList.length != 0">
              <li style="margin-left: 2%;" :title="item.name">{{ item.name }}</li>
              <li class="w-18" :title="item.groupName">{{ item.groupName }}</li>
              <li class="w-90 min-60" :title="statusTxt(item.trainStatus,item)"
                :class="{ 'color-red': item.trainStatus == 4, 'color-green': item.trainStatus == 3, 'color-green2': item.trainStatus == 2 }">
                {{ statusTxt(item.trainStatus) }}</li>
              <li class="w-18" :title="changeTime(item.trainStart)">{{ changeTime(item.trainStart) }}</li>
              <!-- <li class="w-18" :title="changeTime(item.trainEnd)">{{ changeTime(item.trainEnd) }}</li> -->
              <li class="w-90 min-44">{{ getTime(item.trainTime) }}</li>
              <li class="w-90 min-60" :class="{ 'color-green': item.applyStatus }">{{ item.applyStatus ? '启用' : '停用' }}
              </li>
              <li class="w-90 min-60">{{ getTime(item.applyTime) }}</li>
              <li class="w-90 min-60" :class="{ 'color-red': item.lastRunStatus == 2, 'color-green': item.lastRunStatus == 1}" :title="item.lastRunStatus==1?'运行成功':item.lastRunStatus==2?item.lastError.replace('__OAO__','/').replace('__BOB__','/'):'未运行'">{{ item.lastRunStatus==1?"运行成功":item.lastRunStatus==2?"运行失败":"未运行" }}</li>
              <li class="w-90 min-44">{{ item.loss ? item.loss : '-' }}</li>
              <li class="w-26 min-140 operate">
                <span @click="viewMultiModel(item)" :id="`view${i}`">{{ $store.state.isLook?'查看':'编辑' }}</span>
                <span @click="MultiModelResult(item)" :id="`result${i}`":class="{ 'disabled': !functionSetList.includes('aiEdit') || $store.state.isLook || !item.lastResult }">结果</span>
                <span
                  :class="{ 'disabled': !functionSetList.includes('aiEdit') || $store.state.isLook || item.trainStatus == 1 || item.trainStatus == 2 }"
                  @click="operate(item, 'train', i)" :id="`train${i}`">训练</span>
                <span
                  :class="{ 'disabled': !functionSetList.includes('aiEdit') || $store.state.isLook || item.trainStatus != 3 }"
                  @click="operate(item, 'enable', i)" :id="`enable${i}`" v-show="item.applyStatus == 0">启用</span>
                <span
                  :class="{ 'disabled': !functionSetList.includes('aiEdit') || $store.state.isLook || item.trainStatus != 3 }"
                  @click="operate(item, 'disable', i)" :id="`disable${i}`" v-show="item.applyStatus == 1">停用</span>
                <span :class="{ 'disabled': !functionSetList.includes('aiEdit') || $store.state.isLook }"
                  @click="operate(item, 'delete', i)" :id="`delete${i}`">删除</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="company-list clearfix" v-show="state == 1||state == 3">
          <ul class="list-title">
            <li style="margin-left: 3%;">模型名称</li>
            <li class="w-18">所属企业</li>
            <li class="w-90 min-44">训练状态</li>
            <li class="w-18">完成时间</li>
            <li class="w-90">优先级(0-100)</li>
          </ul>
          <div class="scroll">
            <ul class="list-details" v-for="(item, i) in dataList" :key="i" v-show="dataList.length != 0">
              <li style="margin-left: 3%;" :title="item.name">{{ item.name }}</li>
              <li class="w-18" :title="item.groupName">{{ item.groupName }}</li>
              <li class="w-90 min-44" :title="statusTxt(item.trainStatus,item)"
                :class="{ 'color-red': item.trainStatus == 4, 'color-green': item.trainStatus == 3, 'color-green2': item.trainStatus == 2 }">
                {{ statusTxt(item.trainStatus) }}</li>
              <li class="w-18" :title="changeTime(item.trainEnd)">{{ changeTime(item.trainEnd) }}</li>
              <li class="w-90">
                <el-input size="small" :disabled="!functionSetList.includes('aiEdit') || $store.state.isLook"
                  v-model="item.trainSort" @change="setTrainSort(item)"
                  @input="item.trainSort = item.trainSort.replace(/[^\d]/g, '')"></el-input>
              </li>
            </ul>
          </div>
        </div>
        <!-- 没有列表数据 -->
        <div class="nullDataBox" v-show="dataList.length == 0">
          <img :src="nullData" class="nullData">
          <span>什么东西都没有找到...</span>
        </div>
      </div>
      <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
    </div>
    <div class="popup">
      <!-- 新建模型2.2 -->
      <div class="popup-add mode2" :class="{readonlyMode: $store.state.isLook}" v-if="addModeShow || viewMultiShow">
        <div class="popup-title">
          {{ $store.state.isLook ? "查看多参数模型" : viewMode ? "编辑多参数模型" : "新建多参数模型" }}<i class="el-icon-circle-close close" @click="close(viewMode ? 'viewMulti' : 'addMode')"></i>
        </div>
        <div>
          <div class="tabs-box2 clearfix no-flexid">
            <div :class="{ 'active': modeActive == 0 }" @click="modeClick(0)" id="mode0"><span>模型信息</span></div>
            <div :class="{ 'active': modeActive == 1 }" @click="modeClick(1)" id="mode1"><span>输入数据</span></div>
            <div :class="{ 'active': modeActive == 2 }" @click="modeClick(2)" id="mode2"><span>控制数据</span></div>
            <div :class="{ 'active': modeActive == 3 }" @click="modeClick(3)" id="mode3"><span>输出数据</span></div>
            <div :class="{ 'active': modeActive == 4 }" @click="modeClick(4)" id="mode4"><span>目标与约束</span></div>
            <div :class="{ 'active': modeActive == 5 }" @click="modeClick(5)" id="mode5"><span>训练配置</span></div>
          </div>
          <div>
            <el-form :model='modeForm' :rules="modeRules" ref="addModeForm" class="clearfix" :inline="false" :disabled="$store.state.isLook">
              <div v-show="modeActive == 0" class="popup-lab t-left">
                <el-form-item prop="name" label="模型名称：" class="no-title">
                  <el-input v-model="modeForm.name"></el-input>
                </el-form-item>
                <div class="train-box" style="justify-content: space-between;">
                  <el-form-item label="所属企业：" prop="group" autocomplete="off" class="m-t-0 w-50">
                    <div class="popup-lab m-t-0" @mouseleave="selectShow = false"
                      v-show="functionSetList.includes('aiEdit')">
                      <div class="or-Superior" @click='showSelect'>
                        <span class="p-a-l-10">{{ orSuperior.name }}</span>
                        <i><img :src="down" @click="showSelect"></i>
                        <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                          <div class="dashed">
                            <el-tree :data="orSuperiorData" :indent='0' node-key="id" ref="editTree"
                              :highlight-current="true" :default-expand-all="true" :check-on-click-node="false"
                              @node-click="selectId" :props="defaultProps">
                              <span class="custom-tree-node" slot-scope="{ node, data }">
                                <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area"
                                    class="tree-icon"></i>
                                <span>{{ node.label }}<span v-if='data.roleName && data.type != 3'>({{ data.roleName
                                    }})</span></span>
                              </span>
                            </el-tree>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="popup-lab m-t-0" v-show="!functionSetList.includes('aiEdit')">
                      <div class="or-Superior disabled3">
                        <span class="p-a-l-10">{{ orSuperior.name }}</span>
                        <i><img :src="down"></i>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="优先级" prop="trainSort" class="w-50 no-title">
                    <el-input v-model="modeForm.trainSort" placeholder="请输入0~100"
                      @input="modeForm.trainSort = Number(modeForm.trainSort.replace(/[^\d]/g, ''))"></el-input>
                  </el-form-item>
                </div>
                <div class="train-box" style="justify-content: space-between;">
                  <el-form-item label="操作模式：" :required="true"  class="w-50 no-title">
                    <div style="width:100%;padding-top:40px;">
                      <el-radio-group v-model="modeForm.operation" @change="changeOperation">
                        <el-radio label="PREDICT">仅预测</el-radio>
                        <el-radio label="OPTIMIZE">预测并优化</el-radio>
                      </el-radio-group>
                    </div>
                  </el-form-item>

                  <el-form-item label="模型说明：" class="w-50 no-title">
                    <el-input type="textarea" v-model="modeForm.note" rows="5" :autosize="false"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="popup-lab t-left" v-show="modeActive == 1">
                <div class="train-box" style="justify-content: space-between; gap: 10px;">
                  <el-form-item prop="python_config.frequency_seconds" label="采样周期（秒）：" class="block-div no-title">
                    <i><img :src="notes" title="预测跨度秒数" class="notes"></i>
                    <el-input v-model.number="modeForm.python_config.frequency_seconds"></el-input>
                  </el-form-item>
                  <el-form-item prop="python_config.target_shift_steps" label="预测步数：" class=" no-title">
                    <i><img :src="notes" title="第t行的输入预测第t+n行的输出" class="notes"></i>
                    <el-input v-model="modeForm.python_config.target_shift_steps"
                      @input="modeForm.python_config.target_shift_steps = Number(modeForm.python_config.target_shift_steps.replace(/[^\d]/g, ''))"></el-input>
                  </el-form-item>
                  <el-form-item prop="python_config.sample_weight_column" label="样本权重列：" class="block-div no-title">
                    <i><img :src="notes" title="权重用于模型拟合" class="notes"></i>
                    <el-select v-model="modeForm.python_config.sample_weight_column" placeholder="请选择样本权重">
                      <el-option label="不使用样本权重" :value="0"></el-option>
                      <el-option v-for="sources in modeForm.sources" :key="sources.target" :label="sources.name"
                        :value="sources.target" v-if="sources.target">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <el-form-item prop="train" label="训练数据：" class="no-title">
                  <div class="max-h-300">
                    <div class="train-box" v-for="item, i in modeForm.sources" :key="i" style="margin-bottom: 15px;">
                      <!-- 
                      <el-form-item prop="trainDevice" :label="i==0?'产品':''" class="flex-form-item no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select v-model="item.product" placeholder="请选择产品"
                          @change="item.device = ''; item.property = '';">
                          <el-option v-for="product in allProductList" :key="product.code" :label="product.name"
                            :value="product.code">
                          </el-option>
                        </el-select>
                      </el-form-item>
                       -->
                      <el-form-item :prop="'sources.' + i + '.device'" :rules="modeRules['sources.device']" :label="i==0?'设备：':''" class="flex-form-item block-div no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select v-model="item.device" placeholder="请选择设备"
                          @change="item.property = null; devChange(item.device,item)">
                          <el-option v-for="dev in deviceList" :key="dev.code" :label="dev.name" :value="dev.code">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :prop="'sources.' + i + '.property'" :rules="modeRules['sources.property']" :label="i==0?'设备属性：':''" class="flex-form-item block-div no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select v-model="item.property" placeholder="请选择属性" @change="setName($event,item,1)">
                          <el-option v-for="property in getPropertyList(item.device)" :key="property.identifier"
                            :label="property.name" :value="property.identifier" >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :prop="'sources.' + i + '.fill'" :rules="modeRules['sources.fill']" :label="i==0?'填充方式：':''" class="flex-form-item block-div no-title"
                        :disabeld="orSuperior.type != 3">
                        <i><img :src="notes" title="空采样点的填充策略" class="notes" v-if="i==0"></i>
                        <el-select v-model="item.fill" placeholder="请选择填充方式">
                          <el-option label="沿用前值" value="previous"></el-option>
                          <el-option label="补零" value="zero"></el-option>
                          <el-option label="不补值" value="none"></el-option>
                        </el-select>
                      </el-form-item>
                      <span class="delAttr" @click="modeForm.sources.splice(i, 1)" v-show="i != 0">删除</span>
                    </div>
                  </div>
                  <div class="add-train" @click="addSources" v-if="!$store.state.isLook">+添加输入数据</div>
                </el-form-item>
              </div>
              <div class="popup-lab t-left" v-show="modeActive == 2">
                <el-form-item prop="train" label="" class="no-title">
                  <div class="max-h-400">
                    <div class="train-box" style="justify-content: flex-start; flex-wrap: wrap; gap: 10px;margin-bottom: 15px;" :class="{'border':i!=0}" v-for="item, i in modeForm.control_data" :key="i">
                      <!-- 
                      <el-form-item :prop="'python_config.controls.' + i + '.name'" :rules="modeRules['python_config.controls.name']" :label="i==0?'输入数据：':''" class="flex-form-item no-title" :disabeld="orSuperior.type != 3">
                        <el-select :disabled="modeForm.operation=='PREDICT'" v-model="item.name" placeholder="请选择输入数据">
                          <el-option v-for="sources in modeForm.sources" :key="sources.target" :label="sources.name"
                            :value="sources.target" v-if="sources.target" :disabled="sources.disabled">
                          </el-option>
                        </el-select>
                      </el-form-item>
                       -->
                      <el-form-item :prop="'control_data.'+i+'.source.device'" :rules="modeRules['outputs.device']" :label="i == 0 ? '输入设备：' : ''" class="flex-form-item no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select :disabled="modeForm.operation=='PREDICT'" v-model="item.source.device" placeholder="请选择输入设备"
                          @change="item.source.property = null; devChange(item.source.device,item.source)">
                          <el-option v-for="dev in deviceList" :key="dev.code" :label="dev.name" :value="dev.code">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :prop="'control_data.'+i+'.source.property'" :rules="modeRules['outputs.property']" :label="i == 0 ? '输入属性：' : ''" class="flex-form-item no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select :disabled="modeForm.operation=='PREDICT'" v-model="item.source.property" placeholder="请选择输入属性" @change="setName2($event,item.source,i)">
                          <el-option v-for="property in getPropertyList(item.source.device)" :key="property.identifier"
                            :label="property.name" :value="property.identifier" :disabled="property.accessMode=='r'">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :prop="'control_data.'+i+'.optimization_result.device'" :rules="modeRules['outputs.device']" :label="i == 0 ? '写入设备：' : ''" class="flex-form-item no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select :disabled="modeForm.operation=='PREDICT'" v-model="item.optimization_result.device" placeholder="请选择写入设备"
                          @change="item.optimization_result.property = null; devChange(item.optimization_result.device,item.optimization_result)">
                          <el-option v-for="dev in deviceList" :key="dev.code" :label="dev.name" :value="dev.code">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :prop="'control_data.'+i+'.optimization_result.property'" :rules="modeRules['outputs.property']" :label="i == 0 ? '写入属性：' : ''" class="flex-form-item no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select :disabled="modeForm.operation=='PREDICT'" v-model="item.optimization_result.property" placeholder="请选择写入属性">
                          <el-option v-for="property in getPropertyList(item.optimization_result.device)" :key="property.identifier"
                            :label="property.name" :value="property.identifier" :disabled="property.accessMode=='r'">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :prop="'control_data.' + i + '.source.values'" :rules="modeRules['python_config.controls.values']" :label="i==0?'候选值：':''" class="flex-form-item no-title">
                        <i><img :src="notes" title="优化器可以尝试的全部离散值，格式为数字以,分割，如0,1" class="notes" v-if="i==0"></i>
                        <el-input placeholder="请输入候选值" v-model="item.source.values" :disabled="modeForm.operation=='PREDICT'"></el-input>
                      </el-form-item>
                      <el-form-item :prop="'control_data.' + i + '.source.active_values'" :rules="modeRules['python_config.controls.active_values']" :label="i==0?'激活值：':''" class="flex-form-item no-title">
                        <i><img :src="notes" title="哪些值表示设备处于“启用”状态，格式为数字以,分割，如0,1，需存在与候选值" class="notes" v-if="i==0"></i>
                        <el-input placeholder="请输入激活值" v-model="item.source.active_values" :disabled="modeForm.operation=='PREDICT'"></el-input>
                      </el-form-item>
                      <el-form-item :prop="'control_data.' + i + '.source.change_penalty'" :rules="modeRules['python_config.controls.change_penalty']" :label="i==0?'切换惩罚：':''" class="flex-form-item no-title">
                        <i><img :src="notes" title="相对当前状态发生变化时增加的切换惩罚" class="notes" v-if="i==0"></i>
                        <el-input placeholder="请输入切换惩罚" type="number" v-model.number="item.source.change_penalty" :disabled="modeForm.operation=='PREDICT'" ></el-input>
                      </el-form-item>
                      <el-form-item :prop="'control_data.' + i + '.source.fill'" :rules="modeRules['sources.fill']" :label="i==0?'填充方式：':''" class="flex-form-item block-div no-title"
                        :disabeld="orSuperior.type != 3">
                        <i><img :src="notes" title="空采样点的填充策略" class="notes" v-if="i==0"></i>
                        <el-select :disabled="modeForm.operation=='PREDICT'" v-model="item.source.fill" placeholder="请选择填充方式">
                          <el-option label="沿用前值" value="previous"></el-option>
                          <el-option label="补零" value="zero"></el-option>
                          <el-option label="不补值" value="none"></el-option>
                        </el-select>
                      </el-form-item>
                      <span class="delAttr" @click="modeForm.control_data.splice(i, 1)" v-show="i != 0 && modeForm.operation!='PREDICT'">删除</span>
                    </div>
                  </div>
                  <div class="add-train" @click="addControls" v-if="!$store.state.isLook&& modeForm.operation!='PREDICT'">+添加控制数据</div>
                </el-form-item>
              </div>
              <div class="popup-lab t-left" v-show="modeActive == 3">
                <el-form-item prop="outputs" label="" class="no-title">
                  <div class="max-h-400">
                    <div class="train-box output-train-box" style="justify-content: flex-start; gap: 10px;margin-bottom: 15px;" v-for="item, i in modeForm.output_data" :key="i">
                      <!-- 
                      <el-form-item prop="product" :label="i == 0 ? '产品：' : ''" class="flex-form-item no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select v-model="item.product" placeholder="请选择产品"
                          @change="item.device = ''; item.property = '';">
                          <el-option v-for="product in allProductList" :key="product.code" :label="product.name"
                            :value="product.code">
                          </el-option>
                        </el-select>
                      </el-form-item>
                       -->
                      <el-form-item :prop="'output_data.'+i+'.source.device'" :rules="modeRules['outputs.device']" :label="i == 0 ? '设备：' : ''" class="flex-form-item no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select v-model="item.source.device" placeholder="请选择设备"
                          @change="item.source.property = null; devChange(item.source.device,item.source)">
                          <el-option v-for="dev in deviceList" :key="dev.code" :label="dev.name" :value="dev.code">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :prop="'output_data.'+i+'.source.property'" :rules="modeRules['outputs.property']" :label="i == 0 ? '设备属性：' : ''" class="flex-form-item no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select v-model="item.source.property" placeholder="请选择属性" @change="setNameZh(item,i)">
                          <el-option v-for="property in getPropertyList(item.source.device)" :key="property.identifier"
                            :label="property.name" :value="property.identifier">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <!-- 
                      <el-form-item :label="i == 0 ? '写入InfluxDB：' : ''" class="switch-form-item no-title">
                        <i><img :src="notes" title="是否写入InfluxDB" class="notes" v-if="i==0"></i>
                        <el-switch v-model="item.write_influx"></el-switch>
                      </el-form-item>
                       -->
                      <el-form-item :prop="'output_data.'+i+'.prediction_result.device'" :rules="modeRules['outputs.device']" :label="i == 0 ? '写入设备：' : ''" class="flex-form-item no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select v-model="item.prediction_result.device" placeholder="请选择写入设备"
                          @change="item.prediction_result.property = null; devChange(item.prediction_result.device,item.prediction_result)">
                          <el-option v-for="dev in deviceList" :key="dev.code" :label="dev.name" :value="dev.code">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :prop="'output_data.'+i+'.prediction_result.property'" :rules="modeRules['outputs.property']" :label="i == 0 ? '写入属性：' : ''" class="flex-form-item no-title"
                        :disabeld="orSuperior.type != 3">
                        <el-select v-model="item.prediction_result.property" placeholder="请选择写入属性" @change="setName($event,item,2)">
                          <el-option v-for="property in getPropertyList(item.prediction_result.device)" :key="property.identifier"
                            :label="property.name" :value="property.identifier">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :label="i == 0 ? '发布MQTT：' : ''" class="switch-form-item no-title">
                        <i><img :src="notes" title="是否通过MQTT发布该预测结果" class="notes" v-if="i==0"></i>
                        <el-switch v-model="item.prediction_result.publish_mqtt"></el-switch>
                      </el-form-item>
                      <span class="delAttr" @click="modeForm.output_data.splice(i, 1)" v-show="i != 0">删除</span>
                    </div>
                  </div>
                  <div class="add-train" @click="addOutputs" v-if="!$store.state.isLook">+添加输出数据</div>
                </el-form-item>
              </div>
              <div class="popup-lab t-left" v-show="modeActive == 4"> 
                <div class="train-box output-train-box" style="justify-content: flex-start; gap: 10px;margin-bottom: 15px;">
                <el-form-item prop="python_config.objective.target" label="目标数据：" class="w-20 block-div no-title">
                  <el-select :disabled="modeForm.operation=='PREDICT'" v-model="modeForm.python_config.objective.target" placeholder="请选择目标数据">
                    <el-option v-for="outputs in modeForm.output_data" :key="outputs.name" :label="outputs.nameZh"
                      :value="outputs.name" v-if="outputs.name">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :required="true" label="优化方向：" class="w-20 no-title" style="padding-left: 25px; box-sizing: border-box;">
                  <div class="block-div">
                    <el-radio-group :disabled="modeForm.operation=='PREDICT'" v-model="modeForm.python_config.objective.direction" style="margin-top: 5px;">
  <el-radio label="minimize">最小化</el-radio>
  <el-radio label="maximize">最大化</el-radio>
</el-radio-group>
                  </div>
</el-form-item>
<el-form-item prop="python_config.objective.uncertainty_weight" label="不确定性权重：" class="w-20 no-title">
  <i><img :src="notes" title="不确定性惩罚权重，必须大于等于0" class="notes"></i>
  <el-input type="number" :disabled="modeForm.operation=='PREDICT'" v-model="modeForm.python_config.objective.uncertainty_weight" ></el-input>
</el-form-item>
                </div>
<el-form-item prop="train" label="约束条件：" class="no-title">
  <div class="max-h-300">
    <div class="train-box" v-for="item, i in modeForm.python_config.constraints" :key="i" style="margin-bottom: 15px;">
      <el-form-item :prop="'python_config.constraints.'+i+'.target'" :rules="modeRules['python_config.constraints.target']" :label="i==0?'输入数据：':''" class="w-300 block-div  flex-form-item no-title"
        :disabeld="orSuperior.type != 3">
        <el-select :disabled="modeForm.operation=='PREDICT'" v-model="item.target" placeholder="请选择输入数据" @change="setNameByTarget(item,modeForm.output_data)">
          <el-option v-for="outputs in modeForm.output_data" :key="outputs.name" :label="outputs.nameZh"
            :value="outputs.name" v-if="outputs.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :required="true" :label="i==0?'比较函数：':''" class="flex-form-item no-title"
        :disabeld="orSuperior.type != 3">
        <el-select :disabled="modeForm.operation=='PREDICT'" v-model="item.operator" placeholder="请选择比较函数">
          <el-option label=">" value=">"></el-option>
          <el-option label=">=" value=">="></el-option>
          <el-option label="==" value="=="></el-option>
          <el-option label="<" value="<"></el-option>
          <el-option label="<=" value="<="></el-option>
          <el-option label="!=" value="!="></el-option>
        </el-select>
      </el-form-item>
       <el-form-item :prop="'python_config.constraints.'+i+'.value'" :rules="modeRules['python_config.constraints.value']" :label="i==0?'比较值：':''" class="no-title" style="width: 200px !important;">
   <el-input type="number" :disabled="modeForm.operation=='PREDICT'" v-model="item.value" placeholder="请输入数值"></el-input>
 </el-form-item>
      <span style="margin-left: 20px;" class="delAttr" @click="modeForm.python_config.constraints.splice(i, 1)" v-show="i != 0">删除</span>
    </div>
  </div>
  <div class="add-train" @click="addConstraints" v-if="!$store.state.isLook&&modeForm.operation!='PREDICT'">+添加约束数据</div>
</el-form-item>
              </div>
              <div class="popup-lab t-left train-config" v-show="modeActive == 5">
                <!-- 
                <div class="config-section">
                  <h5>训练模型</h5>
                  <p>随机森林训练参数与验证集划分。</p>
                  <div class="config-grid">
                    <el-form-item label="树数量 *" class="config-item no-title">
                      <el-input type="number" v-model.number="modeForm.python_config.model.n_estimators"></el-input>
                    </el-form-item>
                    <el-form-item label="叶节点最小样本" class="config-item no-title">
                      <el-input type="number" v-model.number="modeForm.python_config.model.min_samples_leaf"></el-input>
                    </el-form-item>
                    <el-form-item label="最大深度" class="config-item no-title">
                      <el-input type="number" v-model.number="modeForm.python_config.model.max_depth"
                        placeholder="留空表示不限制"></el-input>
                    </el-form-item>
                    <el-form-item label="验证集比例" class="config-item no-title">
                      <el-input type="number" v-model.number="modeForm.python_config.model.validation_fraction"></el-input>
                    </el-form-item>
                    <el-form-item label="随机种子" class="config-item no-title">
                      <el-input type="number" v-model.number="modeForm.python_config.model.random_state"></el-input>
                    </el-form-item>
                    <el-form-item class="config-item no-title">
                      <template slot="label">
                        并行任务数
                        <el-tooltip content="-1 表示使用全部可用核心" placement="top">
                          <i class="el-icon-question"></i>
                        </el-tooltip>
                      </template>
                      <el-input type="number" v-model.number="modeForm.python_config.model.n_jobs"></el-input>
                    </el-form-item>
                    <el-form-item label="最少训练行数" class="config-item no-title">
                      <el-input type="number" v-model.number="modeForm.python_config.model.min_training_rows"></el-input>
                    </el-form-item>
                    <el-form-item label="目标偏移步数" class="config-item no-title">
                      <el-input type="number" v-model.number="modeForm.python_config.target_shift_steps"></el-input>
                    </el-form-item>
                  </div>
                </div>
                 -->
                <div class="config-section">
                  <h5>控制组合搜索</h5>
                  <p>限制候选组合规模，并决定是否只使用历史出现过的组合。</p>
                  <div class="config-grid">
                    <el-form-item label="最少启用控制量：" prop="python_config.optimization.min_active_controls" class="config-item no-title">
                      <i><img :src="notes" title="最少启用多少个控制量，不能大于控制参数数量和最多启用控制量" class="notes"></i>
                      <el-input :disabled="modeForm.operation=='PREDICT'" v-model.number="modeForm.python_config.optimization.min_active_controls"></el-input>
                    </el-form-item>
                    <el-form-item label="最多启用控制量：" prop="python_config.optimization.max_active_controls" class="config-item no-title">
                      <i><img :src="notes" title="最多启用多少个控制量，不能大于控制参数数量或小于最少启用控制量" class="notes"></i>
                      <el-input :disabled="modeForm.operation=='PREDICT'" v-model.number="modeForm.python_config.optimization.max_active_controls"></el-input>
                    </el-form-item>
                    <el-form-item label="最少历史样本：" prop="python_config.optimization.min_observed_samples" class="config-item no-title">
                      <i><img :src="notes" title="组合至少出现多少次才允许评估" class="notes"></i>
                      <el-input v-model.number="modeForm.python_config.optimization.min_observed_samples"></el-input>
                    </el-form-item>
                    <el-form-item label="最大组合数：" prop="python_config.optimization.max_combinations" class="config-item no-title">
                      <i><img :src="notes" title="原始候选组合数上限，范围1～1,000,000" class="notes"></i>
                      <el-input :disabled="modeForm.operation=='PREDICT'" v-model.number="modeForm.python_config.optimization.max_combinations"></el-input>
                    </el-form-item>
                    <el-form-item label="返回最优方案数：" prop="optimization_request.top_k" class="config-item no-title">
                      <i><img :src="notes" title="最多返回多少个可行方案" class="notes"></i>
                      <el-input :disabled="modeForm.operation=='PREDICT'" v-model.number="modeForm.optimization_request.top_k"></el-input>
                    </el-form-item>
                    <el-form-item label="预测回看步数：" prop="prediction_lookback_steps" class="config-item no-title">
                      <i><img :src="notes" title="周期运行时读取最近多少个采样步" class="notes"></i>
                      <el-input v-model.number="modeForm.prediction_lookback_steps"></el-input>
                    </el-form-item>
                  </div>
                  <div class="config-switches">
                    <el-form-item class="config-switch-item no-title">
                      <el-switch :disabled="modeForm.operation=='PREDICT'" v-model="modeForm.python_config.optimization.only_observed_control_combinations"></el-switch>
                      <span>只搜索训练数据中出现过的控制组合</span>
                    </el-form-item>
                    <el-form-item class="config-switch-item no-title">
                      <el-switch v-model="modeForm.apply_optimized_controls" :disabled="modeForm.operation=='PREDICT'||true"></el-switch>
                      <span>允许系统自动应用推荐的控制参数</span>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-form>
            <div class="btn-box">
              <el-button type="primary" :disabled="!functionSetList.includes('aiEdit') || $store.state.isLook"
                @click='nextTick' id="createBtn" v-if="!viewMultiShow">{{ modeActive==5?'确定':'下一步' }}</el-button>

              <el-button type="primary" :disabled="!functionSetList.includes('aiEdit') || $store.state.isLook"
                @click='nextTick' id="updateBtn" v-if="!addModeShow">{{ modeActive==5?'编辑':'下一步' }}</el-button>
              
              <el-button @click="close(viewMode ? 'viewMulti' : 'addMode')">取消</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 训练模型 -->
      <div class="popup-enable" v-show='trainShow'>
        <div class="popup-title">
          训练模型<i class="el-icon-circle-close close" @click="close('train')" id="closeTrain"></i>
        </div>
        <div class="popup-lab t-left">
          系统将训练该模型 “ {{ nowObj.name }} ”，是否继续
          <p class="btn-box"><el-button type="primary"
              :disabled="!functionSetList.includes('aiEdit') || $store.state.isLook" @click='train'
              id="yesTrain">确定</el-button> <el-button @click="close('train')">取消</el-button></p>
        </div>
      </div>
      <!-- 启用模型 -->
      <div class="popup-enable" v-show='enableShow'>
        <div class="popup-title">
          启用模型<i class="el-icon-circle-close close" @click="close('enable')" id="closeEnable"></i>
        </div>
        <div class="popup-lab t-left">
          系统将启用该模型 “ {{ nowObj.name }} ”，是否继续
          <p class="btn-box"><el-button type="primary"
              :disabled="!functionSetList.includes('aiEdit') || $store.state.isLook" @click='enable'
              id="yesEnable">确定</el-button> <el-button @click="close('enable')">取消</el-button></p>
        </div>
      </div>
      <!-- 删除模型 -->
      <div class="popup-enable" v-show='deleteShow'>
        <div class="popup-title">
          删除模型<i class="el-icon-circle-close close" @click="close('delete')" id="closeEnable"></i>
        </div>
        <div class="popup-lab t-left">
          系统将删除该模型 “ {{ nowObj.name }} ”，是否继续
          <p class="btn-box"><el-button type="primary"
              :disabled="!functionSetList.includes('aiEdit') || $store.state.isLook" @click='deleteModel'
              id="yesDelete">确定</el-button> <el-button @click="close('delete')">取消</el-button></p>
        </div>
      </div>
      <!-- 停用模型 -->
      <div class="popup-enable" v-show='disableShow'>
        <div class="popup-title">
          停用模型<i class="el-icon-circle-close close" @click="close('disable')" id="closeDisable"></i>
        </div>
        <div class="popup-lab t-left">
          系统将停用该模型 “ {{ nowObj.name }} ”，是否继续
          <p class="btn-box"><el-button type="primary"
              :disabled="!functionSetList.includes('aiEdit') || $store.state.isLook" @click='disable'
              id="yesDisable">确定</el-button> <el-button @click="close('disable')">取消</el-button></p>
        </div>
      </div>

      <!-- AI2 运行结果 -->
      <div class="popup-add result-popup" v-show="resultShow">
        <div class="popup-title">
          查看运行结果
          <i class="el-icon-circle-close close" @click="close('result')"></i>
        </div>

        <div class="result-body" v-if="modelResult">
          <div class="result-basic" v-if="false">
            <div class="result-basic-item"><span>最近运行时间：</span>{{ modelResult.lastRunTime || '-' }}</div>
            <div class="result-basic-item"><span>运行状态：</span>
              <b :class="{ 'result-success': modelResult.lastRunStatus == 1, 'result-error': modelResult.lastRunStatus == 2 }">
                {{ modelResult.lastRunStatus == 1 ? '执行成功' : modelResult.lastRunStatus == 2 ? '执行失败' : '未运行' }}
              </b>
            </div>
            <div class="result-basic-item" v-if="modelResult.lastError"><span>错误信息：</span>{{ modelResult.lastError }}</div>
          </div>

          <div v-if="modelResult.data" class="result-data">
            <div class="result-meta">
              <div class="result-meta-card">
                <span class="result-meta-label">模型名称</span>
                <strong class="result-meta-value">{{ nowObj.name || '-' }}</strong>
              </div>
              <div class="result-meta-card">
                <span class="result-meta-label">优化目标</span>
                <strong class="result-meta-value">{{ modelResult.data.result.best ? getNameByTarget(modelResult.data.result.best.objective.target) : '-' }}</strong>
              </div>
              <div class="result-meta-card">
                <span class="result-meta-label">优化方向</span>
                <strong class="result-meta-value">
                  {{ modelResult.data.result.best ? (modelResult.data.result.best.objective.direction == "minimize" ? "最小化" : "最大化") : '-' }}
                </strong>
              </div>
              <div class="result-meta-card">
                <span class="result-meta-label">可行方案</span>
                <strong class="result-meta-value" :class="modelResult.data.result.success ? 'result-success' : 'result-error'">
                  {{ modelResult.data.result.success ? '是' : '否' }}
                </strong>
              </div>
              <div class="result-meta-card">
                <span class="result-meta-label">工况时间</span>
                <strong class="result-meta-value">{{ modelResult.data.result.observed_at || '-' }}</strong>
              </div>
              <div class="result-meta-card">
                <span class="result-meta-label">目标时间</span>
                <strong class="result-meta-value">{{ modelResult.data.result.predicted_for || '-' }}</strong>
              </div>
              <div class="result-message">
                <span class="result-meta-label">结果说明</span>
                <strong>{{ modelResult.data.result.message || '-' }}</strong>
              </div>
            </div>

            <!-- PREDICT -->
            <div v-if="modelResult.data.operation == 'PREDICT'">
              <h4 class="result-section-title">预测结果</h4>
              <el-table :data="modelResult.data.result.predictions || []" border :stripe="false" class="result-table">
                <el-table-column prop="time" label="时间" min-width="180"></el-table-column>
                <el-table-column label="预测值" min-width="260">
                  <template slot-scope="scope">
                    <div v-html="formatResultObject(scope.row.predictions)"></div>
                  </template>
                </el-table-column>
                <el-table-column label="不确定性标准差" min-width="260">
                  <template slot-scope="scope">
                    <div v-html="formatResultObject(scope.row.uncertainty_std)"></div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- OPTIMIZE -->
            <div v-else-if="modelResult.data.operation == 'OPTIMIZE'">
              <div v-if="modelResult.data.result.best" class="candidate-block">
                <h4 class="result-section-title">最优方案</h4>
                <div class="candidate-grid" v-if="false">
                  <div class="candidate-card" >
                    <h5>控制参数</h5>
                    <div v-for="(value,key) in modelResult.data.result.best.controls" :key="key" class="result-kv"><span>{{ key }}</span><b>{{ value }}</b></div>
                  </div>
                  <div class="candidate-card">
                    <h5>预测结果</h5>
                    <div v-for="(value,key) in modelResult.data.result.best.predictions" :key="key" class="result-kv"><span>{{ getNameByTarget(key) }}</span><b>{{ value }}</b></div>
                  </div>
                  <div class="candidate-card" v-if="modelResult.data.result.best.objective">
                    <h5>优化目标</h5>
                    <div class="result-kv"><span>目标</span><b>{{ modelResult.data.result.best.objective.target }}</b></div>
                    <div class="result-kv"><span>方向</span><b>{{ modelResult.data.result.best.objective.direction == 'minimize' ? '最小化' : '最大化' }}</b></div>
                    <div class="result-kv"><span>预测值</span><b>{{ modelResult.data.result.best.objective.predicted_value }}</b></div>
                    <div class="result-kv"><span>保守值</span><b>{{ modelResult.data.result.best.objective.conservative_value }}</b></div>
                    <div class="result-kv"><span>切换惩罚</span><b>{{ modelResult.data.result.best.objective.switch_penalty }}</b></div>
                    <div class="result-kv"><span>调整值</span><b>{{ modelResult.data.result.best.objective.adjusted_value }}</b></div>
                  </div>
                </div>
                <el-table :data="[modelResult.data.result.best]" border :stripe="false" class="result-table" empty-text="无最优方案">
                  <el-table-column label="控制参数" min-width="260">
                    <!-- <template slot-scope="scope">{{ formatResultObject(scope.row.controls) }}</template> -->
                     <template slot-scope="scope"><div v-html="formatResultObject(scope.row.controls)"></div> </template>
                  </el-table-column>
                  <el-table-column label="预测结果" min-width="260">
                    <template slot-scope="scope"><div v-html="formatResultObject(scope.row.predictions)"></div> </template>
                  </el-table-column>
                  <el-table-column align="center" prop="active_control_count" label="预计优化" >
                    <template slot-scope="scope"><div><span class="result-object-value">{{getValueByTarget(modelResult.data.result.estimated_objective_improvement,modelResult.data.result.best.objective.target)}}</span> {{getUnitByTarget(scope.row.objective.target)}}</div> </template>
                  </el-table-column>
                </el-table>

                <h4 class="result-section-title" v-if="modelResult.data.result.best.constraints && modelResult.data.result.best.constraints.length">约束检查</h4>
                <el-table v-if="modelResult.data.result.best.constraints && modelResult.data.result.best.constraints.length" :data="modelResult.data.result.best.constraints" border :stripe="false" class="result-table">
                  <el-table-column prop="name" label="约束名称" min-width="150"></el-table-column>
                  <!-- <el-table-column prop="target" label="目标" min-width="150"></el-table-column> -->
                  <el-table-column prop="operator" label="比较值" width="90">
                    <template slot-scope="scope">{{scope.row.operator}}{{scope.row.required_value}}</template>
                  </el-table-column>
                  <el-table-column prop="predicted_mean" label="预计值" min-width="100">
                    <template slot-scope="scope"><span class="result-object-value">{{getValueByTarget(scope.row.predicted_mean,scope.row.target)}}<em>{{getUnitByTarget(scope.row.target)}}</em></span></template>
                  </el-table-column>
                  <el-table-column prop="conservative_value" label="保守值" min-width="100">
                    <template slot-scope="scope"><span class="result-object-value">{{getValueByTarget(scope.row.conservative_value,scope.row.target)}}<em>{{getUnitByTarget(scope.row.target)}}</em></span></template>
                  </el-table-column>
                  <el-table-column prop="safety_sigma" label="安全系数" width="90"></el-table-column>
                  <el-table-column label="结果" width="90">
                    <template slot-scope="scope">
                      <span :class="scope.row.satisfied ? 'result-success' : 'result-error'">{{ scope.row.satisfied ? '满足' : '不满足' }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="modelResult.data.result.best_effort&&false" class="candidate-block">
                <h4 class="result-section-title">违约最小方案</h4>
                <div class="candidate-grid">
                  <div class="candidate-card">
                    <div v-for="(value,key) in modelResult.data.result.best_effort.controls" :key="key" class="result-kv"><span>{{ key }}</span><b>{{ value }}</b></div>
                  </div>
                  <div class="candidate-card">
                    <div v-for="(value,key) in modelResult.data.result.best_effort.predictions" :key="key" class="result-kv"><span>{{ key }}</span><b>{{ value }}</b></div>
                  </div>
                </div>
              </div>

              <div v-if="modelResult.data.result.current_baseline&&false" class="candidate-block">
                <h4 class="result-section-title">当前控制基线</h4>
                <div class="candidate-grid">
                  <div class="candidate-card">
                    <div v-for="(value,key) in modelResult.data.result.current_baseline.controls" :key="key" class="result-kv"><span>{{ key }}</span><b>{{ value }}</b></div>
                  </div>
                  <div class="candidate-card">
                    <div v-for="(value,key) in modelResult.data.result.current_baseline.predictions" :key="key" class="result-kv"><span>{{ key }}</span><b>{{ value }}</b></div>
                  </div>
                </div>
              </div>

              <div v-if="modelResult.data.result.alternatives" class="candidate-block">
                <h4 class="result-section-title">其他可行方案</h4>
                <el-table :data="modelResult.data.result.alternatives" border :stripe="false" class="result-table alternative-table" empty-text="无其他可行方案">
                  <el-table-column label="控制参数" min-width="300">
                    <template slot-scope="scope"><div v-html="formatResultObject(scope.row.controls)"></div></template>
                  </el-table-column>
                  <el-table-column label="预测结果" min-width="300">
                    <template slot-scope="scope"><div v-html="formatResultObject(scope.row.predictions)"></div></template>
                  </el-table-column>
                  <el-table-column align="center" prop="active_control_count" label="启用数量" width="100">
                    <template slot-scope="scope"><strong class="count-value">{{scope.row.active_control_count}}</strong></template>
                  </el-table-column>
                  <el-table-column align="center" prop="historical_samples" label="历史样本" width="100">
                    <template slot-scope="scope"><strong class="count-value">{{scope.row.historical_samples}}</strong></template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="modelResult.data.result.summary&&false" class="candidate-block">
                <h4 class="result-section-title">搜索统计</h4>
                <div class="summary-grid">
                  <div><span>原始组合数</span><b>{{ modelResult.data.result.summary.raw_combinations }}</b></div>
                  <div><span>实际评估数</span><b>{{ modelResult.data.result.summary.evaluated_combinations }}</b></div>
                  <div><span>可行组合数</span><b>{{ modelResult.data.result.summary.feasible_combinations }}</b></div>
                  <div><span>不可行组合数</span><b>{{ modelResult.data.result.summary.infeasible_combinations }}</b></div>
                </div>
              </div>
            </div>

            <h4 class="result-section-title" v-if="modelResult.data.result.warnings && modelResult.data.result.warnings.length">运行警告</h4>
            <div v-if="modelResult.data.result.warnings && modelResult.data.result.warnings.length" class="result-warning">
              <p v-for="(warning,index) in modelResult.data.result.warnings" :key="index">{{index}}：{{ warning }}</p>
            </div>
          </div>

          <div v-else class="result-empty">
            暂无成功结果可供查看。
          </div>
        </div>

        <div class="btn-box">
          <el-button @click="close('result')">关闭</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/PublicAssembly/pagination"
import Organize from "@/components/PublicAssembly/organize"
import { JSONStringify } from "../../pages/config/functions"
import { valid } from "semver";
export default {
  data() {
    var valiGroup = (rule, value, callback) => {
      if (!this.orSuperior.type) {
        callback(new Error('请选择所属企业'))
      } else if (this.orSuperior.type == 3) {
        callback()
      } else {
        callback(new Error('请选择企业类型'))
      }
    }
    var valiTrain = (rule, value, callback) => {
      callback()
    }
    var valiPredict = (rule, value, callback) => {
      callback()
    }
    var valiPredictWindow = (rule, value, callback) => {
      if (value == 0) {
        callback(new Error('预测时间不能低于1分钟'))
      } else if (value > 1440) {
        callback(new Error('预测时间不能超过1440分钟'))
      } else {
        callback()
      }
    }
    var validatorPredictWindow = (rule, value, callback) => {
      if (value == 0) {
        callback(new Error('预测时间不能低于1分钟'))
      } else if (Number(value) > this.ruleForm.predictWindow) {
        callback(new Error('预测时间不能超过' + this.ruleForm.predictWindow + '分钟'))
      } else {
        callback()
      }
    }

    var validTrainSort = (rule, value, callback) => {
      if (Number(value) > 100 || Number(value) < 0) {
        callback(new Error('请输入0~100的整数'))
      } else {
        callback()
      }
    }
    var validFrequencySeconds = (rule, value, callback) => {
      if(this.modeForm.python_config.frequency_seconds<1){
        callback(new Error('采样周期不能小于1'))
      }else{
        callback()
      }
    }
    var validTargetShiftSteps = (rule, value, callback) => {
      if(this.modeForm.python_config.frequency_seconds<1){
        callback(new Error('预测步数不能小于1'))
      }else{
        callback()
      }
    }
    var validUncertaintyWeight = (rule, value, callback) => {
      if(value<0){
        callback(new Error('不确定性惩罚权重不能小于0'))
      }else{
        callback()
      }
    }

    var validMinActiveControls = (rule, value, callback) => {
      if(this.modeForm.python_config.optimization.min_active_controls > this.modeForm.control_data.length){
        callback(new Error('控制量不能大于控制参数数量'))
      }else if(this.modeForm.python_config.optimization.min_active_controls<1){
        callback(new Error('控制量不能小于1'))
      }else if(this.modeForm.python_config.optimization.max_active_controls<this.modeForm.python_config.optimization.min_active_controls){
        callback(new Error('不能大于最多启用控制量'))
      }else{
        callback()
      }
    }
    var validMaxActiveControls = (rule, value, callback) => {
      if(this.modeForm.python_config.optimization.max_active_controls > this.modeForm.control_data.length){
        callback(new Error('控制量不能大于控制参数数量'))
      }else if(this.modeForm.python_config.optimization.max_active_controls<1){
        callback(new Error('控制量不能小于1'))
      }else if(this.modeForm.python_config.optimization.max_active_controls<this.modeForm.python_config.optimization.min_active_controls){
        callback(new Error('不能小于最少启用控制量'))
      }else{
        callback()
      }
    }
    var validMinObservedSamples = (rule, value, callback) => {
      if(this.modeForm.python_config.optimization.min_observed_samples<1){
        callback(new Error('最少历史样本不能小于1'))
      }else{
        callback()
      }
    }

    var validTopK = (rule, value, callback) => {
      if(this.modeForm.optimization_request.top_k < 1){
        callback(new Error('返回最优方案数不能小于1'))
      }else{
        callback()
      }
    }

    var validLookbackSteps = (rule, value, callback) => {
      if(this.modeForm.prediction_lookback_steps<1){
        callback(new Error('预测回看步数不能小于1'))
      }else{
        callback()
      }
    }

    var validMaxCombinations = (rule, value, callback) => {
      if(this.modeForm.python_config.optimization.max_combinations>1000000||this.modeForm.python_config.optimization.max_combinations<1){
        callback(new Error('请输入1～1000000的数'))
      }else{
        callback()
      }
    }
    var validArrString = (rule, value, callback)=>{
      var valid = /^[-+]?\d*\.?\d+(,[-+]?\d*\.?\d+)*$/.test(value);
      if(valid){
        callback()
      }else{
        callback(new Error('格式错误，示例：0,1'))
      }
    }

    return {
      Tree: [],
      setOrcode: false,
      orCode: 1,
      orSuperior: {}, //上级组对象
      oldorSuperior: {},
      orSuperiorData: [], //所属组tree结构数据
      functionSetList: [],
      nullData: require('@/assets/image/index/nullData.png'),
      down: require('@/assets/image/organize/down.png'),
      area: require('@/assets/image/company/qyzu.png'),
      branch: require('@/assets/image/company/ptzu.png'),
      location: require('@/assets/image/company/jczu.png'),
      notes:require('@/assets/image/organize/notes.png'),
      VerifyArr: [],
      state: 2,
      dataList: [],
      targetNameArr:[],
      targetArr:[],
      modeForm: {
        name: "",//模型名称
        note: "",//模型描述
        trainSort: "",//优先级
        apply_optimized_controls:false, //是否通过MQTT下发最优控制量
        //输入数据源
        sources: [
          {
            name: null,
            product: null,
            device: null,
            property: null,
            fill: null
          },
        ],
        // 控制数据
        control_data:[{
          name:"",
          source:{
            product: null,
            device: null,
            property: null,
            fill: null,
            values: null,
            active_values: null,
            change_penalty: 0.5,
          },
          optimization_result:{
            product: null,
            device: null,
            property: null,
            write_influx: true
          }
        }],
        output_data: [
          {
            name: null,
            source: {
                product: null,
                device:  null,
                property:  null,
            },
            prediction_result: {
                product:  null,
                device:  null,
                property:  null,
                write_influx: true,
                publish_mqtt: false
            }
        },
        ],
        operation: "OPTIMIZE", //操作模式
        prediction_lookback_steps: 1, //预测回看步数
        python_config: {
          time_column: "time",//时间列
          target_shift_steps: 1,
          frequency_seconds: 60,
          sample_weight_column: 0,
          model: {
            n_estimators: 300,
            min_samples_leaf: 2,
            max_depth: null,
            validation_fraction: 0.2,
            random_state: 42,
            n_jobs: -1,
            min_training_rows: 80
          },
          input_columns: [],//输入数据-target
          target_columns: [],//输出数据-target
          controls: [],//控制数据
          objective: {
            target: "",
            direction: "minimize",
            uncertainty_weight: 0.2
          },//目标数据
          constraints: [
            {
              name: "",
              target: "",
              operator: ">=",
              // requirement: "",
              // input_column: "",
              safety_sigma: null,
              value: null
            }
          ],//限制数据
          optimization: {  //训练配置
            min_active_controls: 1,
            max_active_controls: 1,
            only_observed_control_combinations: true,
            min_observed_samples: 5,
            max_combinations: 65536,
          },
        },
        optimization_request:{
          fixed_inputs: {},
          requirements: {
            min_pressure_mpa: 0.6
          },
          current_controls: {},
          allowed_values: {},
          locked_controls: {},
          top_k: 5
        },
      },
      modeRules: {
        name: [{
          required: true,
          message: '请输入模型名称',
          trigger: 'blur'
        },
        {
          max: 32,
          message: '最大支持32个字符',
          trigger: 'blur'
        },
        ],
        group: [{
          required: true,
          validator: valiGroup,
          trigger: 'submit'
        }],
        trainSort: [{
          required: true,
          message: '请输入优先级',
          trigger: 'blur'
        }, {
          required: true,
          validator: validTrainSort,
          trigger: 'change'
        }],
        "sources.device": {
          required: true,
          message: '请选择设备',
          trigger: 'change'
        },
        "sources.property": {
          required: true,
          message: '请选择设备属性',
          trigger: 'change'
        },
        "sources.fill": {
          required: true,
          message: '请选择填充方式',
          trigger: 'change'
        },
        "python_config.controls.name": {
          required: true,
          message: '请选择输入数据',
          trigger: 'change'
        },
        "python_config.controls.values": [{
          required: true,
          message: '请输入候选值',
          trigger: 'change'
        },{
          required: true,
          validator: validArrString,
          trigger: 'change'
        }],  
        "python_config.controls.active_values": [{
          required: true,
          message: '请输入激活值',
          trigger: 'change'
        },{
          required: true,
          validator: validArrString,
          trigger: 'change'
        }],
        "python_config.controls.change_penalty": {
          required: true,
          message: '请输入切换惩罚',
          trigger: 'change'
        },
        "outputs.device": {
          required: true,
          message: '请选择设备',
          trigger: 'change'
        },
        "outputs.property": {
          required: true,
          message: '请选择设备属性',
          trigger: 'change'
        },
        "python_config.frequency_seconds": [{
          required: true,
          message: '请输入采样周期',
          trigger: 'change'
        },{
          required: true,
          validator: validFrequencySeconds,
          trigger: 'change'
        }],
        "python_config.target_shift_steps": [{
          required: true,
          message: '请输入预测步数',
          trigger: 'change'
        },{
          required: true,
          validator: validTargetShiftSteps,
          trigger: 'change'
        }],
        "python_config.sample_weight_column": {
          required: true,
          message: '请选择样本权重',
          trigger: 'change'
        },
        "python_config.objective.target": {
          required: true,
          message: '请选择目标数据',
          trigger: 'change'
        },
        "python_config.objective.uncertainty_weight": [{
          required: true,
          message: '请输入不确定性权重',
          trigger: 'change'
        },{
          required: true,
          validator: validUncertaintyWeight,
          trigger: 'change'
        }],
        "python_config.constraints.target":{
          required: true,
          message: '请选择输入数据',
          trigger: 'change'
        },
        "python_config.constraints.operator":{
          required: true,
          message: '请选择比较函数',
          trigger: 'change'
        },
        "python_config.constraints.value":{
          required: true,
          message: '请输入比较值',
          trigger: 'change'
        },
        "python_config.optimization.min_active_controls": [{
          required: true,
          message: '请输入最少启用控制量',
          trigger: 'change'
        },{
          required: true,
          validator: validMinActiveControls,
          trigger: 'change'
        }],

        "optimization_request.top_k": [{
          required: true,
          message: '请输入返回最优方案数',
          trigger: 'change'
        },{
          required: true,
          validator: validTopK,
          trigger: 'change'
        }],

        prediction_lookback_steps: [{
          required: true,
          message: '请输入预测回看步数',
          trigger: 'change'
        },{
          required: true,
          validator: validLookbackSteps,
          trigger: 'change'
        }],
        "python_config.optimization.max_active_controls": [{
          required: true,
          message: '请输入最多启用控制量',
          trigger: 'change'
        },{
          required: true,
          validator: validMaxActiveControls,
          trigger: 'change'
        }],
        "python_config.optimization.min_observed_samples": [{
          required: true,
          message: '请输入最少历史样本',
          trigger: 'change'
        },{
          required: true,
          validator: validMinObservedSamples,
          trigger: 'change'
        }],
        "python_config.optimization.max_combinations": [{
          required: true,
          message: '请输入最大组合数',
          trigger: 'change'
        },{
          required: true,
          validator: validMaxCombinations,
          trigger: 'change'
        }]
      },
      ruleForm: {
        name: "",
        trainDevice: "",
        trainProperty: "",
        predictWindow: 1,
        predictDevice: "",
        predictProperty: "",
        extend: [],
        trainSort: 1
      },
      rules: {
        checkSubWindow: [{
          required: true,
          validator: validatorPredictWindow,
          trigger: 'change'
        }],
        trainSort: [{
          required: true,
          message: '请输入优先级',
          trigger: 'blur'
        }, {
          required: true,
          validator: validTrainSort,
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入模型名称',
          trigger: 'blur'
        },
        {
          max: 32,
          message: '最大支持32个字符',
          trigger: 'blur'
        },
        ],
        group: [{
          required: true,
          validator: valiGroup,
          trigger: 'submit'
        }],
        train: [{
          required: true,
          validator: valiTrain,
          trigger: 'submit'
        }],
        predict: [{
          required: true,
          validator: valiPredict,
          trigger: 'submit'
        }],
        trainDevice: [{
          required: true,
          message: '请选择设备',
          trigger: 'change'
        }],
        trainProperty: [{
          required: true,
          message: '请选择设备属性',
          trigger: 'change'
        }],
        predictWindow: [{
          required: true,
          message: '请输入预测时间',
          trigger: 'change'
        }, {
          required: true,
          validator: valiPredictWindow,
          trigger: 'change'
        }],
        predictDevice: [{
          required: true,
          message: '请选择设备',
          trigger: 'change'
        }],
        predictProperty: [{
          required: true,
          message: '请选择设备属性',
          trigger: 'change'
        }],
      },
      totalCount: 1,
      addShow: false,
      addModeShow: false,
      viewMultiShow: false,
      modelLoading:false,
      viewMode: false,
      modeActive: 0,
      enableShow: false,
      disableShow: false,
      deleteShow: false,
      selectShow: false,
      viewShow: false,
      trainShow: false,
      resultShow: false,
      modelResult: null,
      nowIndex: null,
      nowObj: {},
      roleId: null,
      deviceList: [],
      productList: [],
      allProductList: [],
      pageNumber: 1,
      defaultProps: {
        children: 'children',
        label: 'name',
        disabled: (data, node) => {
          if (data.type == 3) {
            return false
          } else {
            return true
          }
        }
      },
    }
  },
  components: {
    Pagination,
    Organize
  },
  computed: {
    getNameByTarget(){
      return (target)=>{
        var obj = this.targetNameArr.find(item=>item.target==target)
        return obj?obj.name:target
      }
    },
    getUnitByTarget(){
      return (target)=>{
        var obj = this.targetNameArr.find(item=>item.target==target)
        return obj&&obj.unit?obj.unit:""
      }
    },
    getValueByTarget(){
      return (value,target)=>{
        var obj = this.targetNameArr.find(item=>item.target==target)
        if(!obj) return value
        if(obj.type=='bool'||obj.type=='enum'){
          return obj.specs[value]
        }else if(obj.type=='float'||obj.type=='int'||obj.type=='double'){
          var factor = Math.pow(10, obj.decimal)
          var result = Math.trunc(Number(value) * factor) / factor;
          return result.toFixed(obj.decimal);
        }else{
          return value
        }
      }
    },
    getPropertyList() {
      return (code) => {
        if (code) {
          let dev = this.deviceList.find(item => item.code == code)
          if (!dev) {
            return []
          }
          let pro = this.productList.find(item => item.id == dev.productId)

          if (!pro) {
            return []
          } else {
            let dev = this.deviceList.find(item=>item.code==code)
            
            if(!dev){
              return []
            }
            let properties = pro.properties.filter(item=>dev.propertySet.includes(item.identifier))
            return properties || []
          }
        } else {
          return []
        }
      }
    },
    checkShow() {
      return (code, identifier) => {
        if (!code || !identifier) {
          return false
        } else {
          let dev = this.deviceList.find(item => item.code == code)
          if (!dev) { return false }
          return dev.propertySet.includes(identifier)
        }
      }
    },
    statusTxt() {
      return (status,item) => {
        if (status == 1) {
          return '待训练'
        } else if (status == 2) {
          return '训练中'
        } else if (status == 3) {
          return '训练完成'
        } else if (status == 4) {
          return item?item.lastError.replace('__OAO__','/'):'训练失败'
        } else {
          return '未训练'
        }
      }
    },
    getTime() {
      return (seconds) => {
        if (seconds > 0) {
          const hours = Math.floor(seconds / 3600);
          const minutes = Math.floor((seconds % 3600) / 60);
          const secs = seconds % 60;

          return [hours, minutes, secs]
            .map(num => (num < 10 ? '0' + num : num))
            .filter((num, i) => i > 0 || hours > 0)
            .join(':');
        } else {
          return '-'
        }
      }
    },
  },
  created() {
    this.$store.state.mask = false
    this.$store.state.activeIndex = '/MultiModel'
    this.getTree('a')
    this.pageSize = this.$store.state.userConfig.rowsPerPage;
  },
  methods: {
    changeWindow() {
      for (let i in this.ruleForm.extend) {
        this.$refs.addForm.validateField('extend.' + i + '.predictWindow')
      }
    },
    // 新增预测数据
    addTrain() {
      this.$set(this.ruleForm.extend, this.ruleForm.extend.length, {
        predictWindow: 1,
        predictDevice: "",
        predictProperty: ""
      })
    },
    addSources() {
      this.modeForm.sources.push({
        name: null,
        product: null,
        device: null,
        property: null,
        fill: null,
      })
    },
    addOutputs() {
      this.modeForm.output_data.push({
        name: null,
        source: {
          product: null,
          device: null,
          property: null,
        },
        prediction_result: {
          product: null,
          device: null,
          property: null,
          write_influx: true,
          publish_mqtt: false
        }
      })
    },
    addConstraints(){
      this.modeForm.python_config.constraints.push({
        name: "",
        operator: ">=",
        // input_column: "",
        target: "",
        safety_sigma: null,
        value:null
      })
    },
    addControls() {
      this.modeForm.control_data.push({
        name:"",
        source:{
          product: null,
          device: null,
          property: null,
          fill: null,
          values: null,
          active_values: null,
          change_penalty: 0.5,
        },
        optimization_result:{
          product: null,
          device: null,
          property: null,
          write_influx: true
        }
      })
    },
    // 修改名称
    setName(e,item,type) {
      let dev = this.deviceList.find(dev => dev.code == item.device)
      let pro = this.productList.find(pro => pro.productKey == item.product)
      if(!pro) return
      let proper  = pro.properties.find(proper => proper.identifier == item.property)
      if(!dev || !proper){
        return
      }
      if(proper.accessMode=='r'){
        item.disabled = true
      }else{
        item.disabled = false
      }
      var oldTarget = item.target
      if(oldTarget&&type==1){
        for(let obj of this.modeForm.python_config.controls){
          // console.log(obj.name == oldTarget,obj.name,oldTarget)
          if(obj.name == oldTarget){
              obj.name= "",
              obj.values= null,
              obj.active_values= null,
              obj.change_penalty= 0.5
          }
        }
      }else if(oldTarget&&type==2){
        for(let obj of this.modeForm.python_config.constraints){
          // console.log(obj.target == oldTarget,obj.target,oldTarget)
          if(obj.target == oldTarget){
              obj.name = "",
              obj.target = "",
              obj.value= null
          }
        }
      }
      item.name = `${dev.name}/${proper.name}`
      item.target = `${item.device}__OAO__${proper.identifier}`
      this.$forceUpdate()
    },
    setName2(e,item,index) {
      item.values=null
      item.active_values=null
      item.change_penalty=0.5
      
      this.modeForm.control_data[index].name = `${item.device}__OAO__${item.property}`
      this.$forceUpdate()
    },
    setNameZh(item,index,isView){
      if(!isView){item.name=`${item.source.device}__BOB__${item.source.property}`}
      let dev = this.deviceList.find(dev => dev.code == item.source.device)
      let pro = this.productList.find(pro => pro.productKey == item.source.product)
      if(!pro) return
      let proper  = pro.properties.find(proper => proper.identifier == item.source.property)
      if(!dev || !proper){
        return
      }
      item.nameZh = `${dev.name}/${proper.name}`
    },
    setNameByTarget(item,arr){
      let target = arr.find(target => target.name == item.target)
      if(!target){
        return
      }
      item.name = target.nameZh
    },
    // 变更设备 - new
    async devChange(code, item) {
      let dev = this.deviceList.find(item => item.code == code)
      if (!dev) {
        return
      }
      let pro = this.productList.find(item => item.id == dev.productId||item.productKey==item.product)
      if (!pro) {
        await this.getTsl(code, dev.productId,item)
      }
      if(pro&&item) {
        item.product = pro.productKey
      }
    },
    // 获取tsl
    getTsl(code, pid,item) {
      this.get('/ProductFeature/getByDeviceCode?code=' + code).then(res => {
        if (res.success) {
          res.result = JSON.parse(res.result)
          res.result.properties.forEach(item => {
            if(item.dataType.type!='enum'&&item.dataType.type!='bool'){
              item.disabled = true
            }
          })
          let pro = {
            id: pid,
            properties: res.result.properties,
            productKey: res.result.profile.productKey
          }
          if(item){
            item.product = pro.productKey
          }
          this.productList.push(pro)
        } else {
          this.$message({
            message: `获取设备属性失败:${res.message}`,
            type: 'warning'
          });
        }
      })
    },
    // 展开上级组
    showSelect() {
      var box = this.$refs.selectbox;
      this.selectShow = true;
    },
    // 获取用户点击的上级组节点
    selectId(data) {
      if (this.orSuperior.code == data.code) {
        this.selectShow = false;
        return
      }
      this.orSuperior = data;
      this.ruleForm.groupCode = data.code;
      this.selectShow = false;
      if(this.addShow){
        this.$refs.addForm.validateField("group")
      }else{
        this.$refs.addModeForm.validateField("group")
      }
      let groupCode = null,
        deviceList = []
      if (data.type == 3) {
        groupCode = data.code
        this.get('/Device/getList', {
          companyId: data.id
        }).then(res => {
          if (res.success) {
            res.result.forEach(item => {
              item.propertySet = item.propertySet.split(',')
            })
            this.deviceList = res.result
            deviceList = res.result
          } else {
            this.$message({
              message: `获取企业设备列表失败:${res.message}`,
              type: 'warning'
            });
          }
        })
      }
      this.ruleForm.trainDevice = ""
      this.ruleForm.trainProperty = ""
      this.ruleForm.predictDevice = ""
      this.ruleForm.predictProperty = ""
      for (let item of this.ruleForm.extend) {
        item.predictDevice = ""
        item.predictProperty = ""
      }
      this.$forceUpdate()
    },
    // 下一步
    nextTick(){
      // if(this.viewMode){
        // this.modeActive += 1
        // return;
      // }
      switch(this.modeActive){
        case 0:
          var valid = true
          this.$refs.addModeForm.validateField(['name','group','trainSort'],error => {
            if (error) {
              valid = false
            }      
          })
          if (valid) {
            this.modeActive += 1
          }
          break;
        case 1:
          var valid = true
          var propArr = ['python_config.frequency_seconds','python_config.target_shift_steps','python_config.sample_weight_column']
          this.modeForm.sources.forEach((item,index) => {
            propArr.push(`sources.${index}.device`)
            propArr.push(`sources.${index}.property`)
            propArr.push(`sources.${index}.fill`)
          })
          this.$refs.addModeForm.validateField(propArr,error => {
            if (error) {
              valid = false
            }      
          })
          if (valid) {
            this.modeActive += 1
          }
          break;
        case 2:
          var valid = true
          var propArr = []
          this.modeForm.control_data.forEach((item,index) => {
            propArr.push(`control_data.${index}.source.device`)
            propArr.push(`control_data.${index}.source.property`)
            propArr.push(`control_data.${index}.source.values`)
            propArr.push(`control_data.${index}.source.active_values`)
            propArr.push(`control_data.${index}.source.change_penalty`)
            propArr.push(`control_data.${index}.source.fill`)
            propArr.push(`control_data.${index}.optimization_result.device`)
            propArr.push(`control_data.${index}.optimization_result.property`)
          })
          if(this.modeForm.operation=='PREDICT'){
            this.$refs.addModeForm.clearValidate(propArr)
            this.modeActive += 1
          }else{
            this.$refs.addModeForm.validateField(propArr,error => {
              if (error) {
                valid = false
              }      
            })
            if (valid) {
              this.modeActive += 1
            }
          }
          break;
        case 3:
          var valid = true
          var propArr = []
          this.modeForm.output_data.forEach((item,index) => {
            propArr.push(`output_data.${index}.source.device`)
            propArr.push(`output_data.${index}.source.property`)
            propArr.push(`output_data.${index}.prediction_result.device`)
            propArr.push(`output_data.${index}.prediction_result.property`)
          })
          this.$refs.addModeForm.validateField(propArr,error => {
            if (error) {
              valid = false
            }      
          })
          if (valid) {
            this.modeActive += 1
          }
          break;
        case 4:
          var valid = true
          var propArr1 = ["python_config.objective.target","python_config.objective.uncertainty_weight"]
          var propArr = []
          this.modeForm.python_config.constraints.forEach((item,index) => {
            propArr.push(`python_config.constraints.${index}.target`)
            propArr.push(`python_config.constraints.${index}.value`)
            propArr.push(`python_config.controls.${index}.output_device`)
            propArr.push(`python_config.controls.${index}.output_property`)
          })
           var validArr=propArr1.concat(propArr)
          if(this.modeForm.operation=='PREDICT'){
            this.$refs.addModeForm.clearValidate(validArr)
            /**
            this.$refs.addModeForm.validateField(propArr1,error => {
              if (error) {
                valid = false
              }      
            })
            **/ 
          }else{
            this.$refs.addModeForm.validateField(validArr,error => {
              if (error) {
                valid = false
              }      
            })
          }
          if (valid) {
            this.modeActive += 1
          }
          break;
        case 5:
          this.createMultiModel()
          break;
        default:
          this.modeActive += 1
      }
    },
    changeOperation(){
      if(this.modeForm.operation=='PREDICT'){
        this.modeForm.apply_optimized_controls = false
      }
    },
    // 创建多参数模型
    createMultiModel(){
      var valid = true,errArr = [],modelArr = []
      // 模型信息验证
      this.$refs.addModeForm.validateField(['name','group','trainSort'],error => {
        if (error) {
          valid = false
          if(!errArr.includes(0)){
            errArr.push(0)
            modelArr.push("模型信息")
          }
        }      
      })
      // 输入数据验证
      var propArr1 = ['python_config.frequency_seconds','python_config.target_shift_steps','python_config.sample_weight_column']
      this.modeForm.sources.forEach((item,index) => {
        propArr1.push(`sources.${index}.device`)
        propArr1.push(`sources.${index}.property`)
        propArr1.push(`sources.${index}.fill`)
      })
      this.$refs.addModeForm.validateField(propArr1,error => {
        if (error) {
          valid = false
          if(!errArr.includes(1)){
            errArr.push(1)
            modelArr.push("输入数据")
          }
        }      
      })
      // 控制数据验证
      var propArr2 = []
      this.modeForm.control_data.forEach((item,index) => {
        propArr2.push(`control_data.${index}.source.device`)
        propArr2.push(`control_data.${index}.source.property`)
        propArr2.push(`control_data.${index}.source.values`)
        propArr2.push(`control_data.${index}.source.active_values`)
        propArr2.push(`control_data.${index}.source.change_penalty`)
        propArr2.push(`control_data.${index}.source.fill`)
        propArr2.push(`control_data.${index}.optimization_result.device`)
        propArr2.push(`control_data.${index}.optimization_result.property`)
      })
      if(this.modeForm.operation=='PREDICT'){
        this.$refs.addModeForm.clearValidate(propArr2)
      }else{
        this.$refs.addModeForm.validateField(propArr2,error => {
          if (error) {
            valid = false
            if(!errArr.includes(2)){
              errArr.push(2)
              modelArr.push("控制数据")
            }
          }      
        })
      }
      // 输出数据验证
      var propArr3 = []
      this.modeForm.output_data.forEach((item,index) => {
        propArr3.push(`output_data.${index}.source.device`)
        propArr3.push(`output_data.${index}.source.property`)
        propArr3.push(`output_data.${index}.prediction_result.device`)
        propArr3.push(`output_data.${index}.prediction_result.property`)
      })
      this.$refs.addModeForm.validateField(propArr3,error => {
        if (error) {
          valid = false
          if(!errArr.includes(3)){
            errArr.push(3)
            modelArr.push("输出数据")
          }
        }      
      })
      // 目标与约束
      var propArrobjective = ["python_config.objective.target","python_config.objective.uncertainty_weight"]
      var propArr4 = []
      this.modeForm.python_config.constraints.forEach((item,index) => {
        item.value = Number(item.value)
        propArr4.push(`python_config.constraints.${index}.target`)
        propArr4.push(`python_config.constraints.${index}.value`)
        propArr4.push(`python_config.controls.${index}.output_device`)
        propArr4.push(`python_config.controls.${index}.output_property`)
      })
      var validArr = propArrobjective.concat(propArr4)
      if(this.modeForm.operation=='PREDICT'){
        this.$refs.addModeForm.clearValidate(validArr)
        /**
        this.$refs.addModeForm.validateField(propArrobjective,error => {
          if (error) {
            valid = false
            if(!errArr.includes(4)){
              errArr.push(4)
              modelArr.push("目标与约束")
            }
          }      
        })
        **/ 
      }else{
        this.$refs.addModeForm.validateField(validArr,error => {
          if (error) {
            valid = false
            if(!errArr.includes(4)){
              errArr.push(4)
              modelArr.push("目标与约束")
            }
          }      
        })
      }
      // 训练配置验证
      var propArr5 = ["python_config.optimization.min_active_controls","python_config.optimization.max_active_controls","python_config.optimization.min_observed_samples","python_config.optimization.max_combinations","optimization_request.top_k","prediction_lookback_steps"]
      if(this.modeForm.operation=='PREDICT'){
        this.$refs.addModeForm.clearValidate(["python_config.optimization.min_active_controls","python_config.optimization.max_active_controls","python_config.optimization.max_combinations","optimization_request.top_k"])
        propArr5 =["python_config.optimization.min_observed_samples","prediction_lookback_steps"]
      }
      this.$refs.addModeForm.validateField(propArr5,error => {
        if (error) {
          valid = false
          if(!errArr.includes(5)){
            errArr.push(5)
            modelArr.push("训练配置")
          }
        }      
      })
      // 验证结果
      if (!valid) {
        this.modeActive=errArr[0]
        this.$message({
          message:`请检查${modelArr.toString()}模块的数据`,
          type:"warning"
        })
        return
      }
      let modeForm = JSON.parse(JSON.stringify(this.modeForm))
      let obj = {
        name: modeForm.name,
        note: modeForm.note,
        trainSort: Number(modeForm.trainSort),
        groupCode: this.orSuperior.code,
      }
      if (this.viewMultiShow){obj.id=this.nowObj.id}
      modeForm.python_config.objective.uncertainty_weight = Number(modeForm.python_config.objective.uncertainty_weight)
      // 处理 input_data
      modeForm.input_data=[]
      for(let item of modeForm.sources){
        modeForm.input_data.push({
          name:`${item.device}__OAO__${item.property}`,
          source:{
            product:item.product,
            device:item.device,
            property:item.property,
            fill:item.fill,
          }
        })
      }
      
      let control_data = modeForm.control_data.filter(item=>item.name)
      modeForm.control_data = control_data
      let sourcesNames = modeForm.sources.map(item => `${item.device}__OAO__${item.property}`)
      let controlNames = control_data.map(item => item.name)
      modeForm.python_config.input_columns = sourcesNames.concat(controlNames)
      // 输出数据使用独立标识符，避免与输入/控制数据的 __OAO__ 冲突。
      // 无论是新建还是编辑旧模型，都根据输出源设备和属性重新生成 __BOB__ 标识符。
      modeForm.output_data.forEach(item => {
        item.name = `${item.source.device}__BOB__${item.source.property}`
      })
      modeForm.python_config.target_columns = modeForm.output_data.map(item => item.name)
      if(modeForm.operation=='PREDICT'){
        // 移除控制参数和约束
        delete modeForm.python_config.controls
        delete modeForm.python_config.constraints
        modeForm.control_data = null
        modeForm.python_config.input_columns = sourcesNames
      }else{
        modeForm.python_config.controls = []
        modeForm.control_data.forEach(item=>{
          modeForm.python_config.controls.push({
            name:item.name,
            values:item.source.values?item.source.values.split(',').map(Number):"",
            active_values: item.source.active_values?item.source.active_values.split(',').map(Number):"",
            change_penalty:item.source.change_penalty
          })
          delete item.source.values
          delete item.source.active_values
          delete item.source.change_penalty
        })
      }
      // var sample_weight_column_obj = modeForm.sources.find(item => item.target == this.modeForm.python_config.sample_weight_column )
      if(modeForm.python_config.sample_weight_column==0){
        modeForm.python_config.sample_weight_column = null
      }
      modeForm.output_data.forEach(item=>{
        delete item.nameZh
      })
      
      delete modeForm.sources
      // modeForm.sources.forEach(item => {
        // item.name = item.target
        // if(!item.fill){
          // item.fill = 'none'
        // }
        // delete item.target
        // delete item.write_influx
        // delete item.publish_mqtt
        // delete item.disabled
      // })
      // modeForm.outputs.forEach(item => {
        // delete item.disabled
        // delete item.name
      // })
      obj.extend = JSON.stringify(modeForm)
      // console.log(obj)
      // return
      let url = this.addModeShow?"/AI2/create":"/AI2/update"
      this.postNoJson(url, obj).then(res => {
        if (res.success) {
          this.$message({
            message: this.addModeShow?"新建成功":"修改成功",
            type: 'success'
          });
          this.$store.state.mask = false;
          this.addModeShow = false;
          this.viewMultiShow = false
          this.getlist();
        } else {
          this.$message({
            message: `新建失败：${res.message}`,
            type: 'warning'
          });
        }
      })
    },
    // 查看多参数模型
    viewMultiModel(obj){
      this.nowObj = this.clone(obj);
      this.nowObj.extend = JSON.parse(this.nowObj.extend)
      // 根据extend还原查看表单
      this.modeForm = this.clone(this.nowObj.extend);
      if(!this.modeForm.python_config.sample_weight_column){
        this.modeForm.python_config.sample_weight_column = 0
      }
      if(this.modeForm.operation=="PREDICT"){
        this.$set(this.modeForm.python_config,"objective",
        {
          target: "",
          direction: "minimize",
          uncertainty_weight: 0.2
        })
        this.$set(this.modeForm.python_config,"optimization",
        {  //训练配置
          min_active_controls: 1,
          max_active_controls: 1,
          only_observed_control_combinations: true,
          min_observed_samples: 5,
          max_combinations: 65536,
        })
        this.$set(this.modeForm,"optimization_request",
        {
          fixed_inputs: {},
          requirements: {
            min_pressure_mpa: 0.6
          },
          current_controls: {},
          allowed_values: {},
          locked_controls: {},
          top_k: 5
        })
        this.modeForm.python_config.controls=[],//控制数据
        this.$set(this.modeForm.python_config,"constraints",
        [
          {
            name: "",
            target: "",
            operator: ">=",
            // requirement: "",
            // input_column: "",
            safety_sigma: null,
            value: null
          }
        ])
        this.$set(this.modeForm,"control_data",
        [{
          name:"",
          source:{
            product: null,
            device: null,
            property: null,
            fill: null,
            values: null,
            active_values: null,
            change_penalty: 0.5,
          },
          optimization_result:{
            product: null,
            device: null,
            property: null,
            write_influx: true
          }
        }])
      }else{
        for(let item of this.modeForm.control_data){
          var control = this.modeForm.python_config.controls.find(obj=>obj.name == item.name)
          this.$set(item.source,"values",control.values.toString())
          this.$set(item.source,"active_values",control.active_values.toString())
          this.$set(item.source,"change_penalty",control.change_penalty)
          // item.source.values = control.values.toString()
          // item.source.active_values = control.active_values.toString()
          // item.source.change_penalty = control.change_penalty
        }
      }
      this.viewMode = true;
      this.get('/Company/get?code=' + this.nowObj.groupCode).then(res => {
        if (res.success) {
          res.result[0].name = res.result[0].shortName
          this.orSuperior = res.result[0]
          this.orSuperior.type = 3
          this.get('/Device/getList', {
            companyId: res.result[0].id
          }).then(async res => {
            if (res.success) {
              let sources = this.modeForm.input_data
              let allSources = this.modeForm.input_data.concat(this.modeForm.control_data).concat(this.modeForm.output_data)
              // this.modeForm.sources = []
              this.$set(this.modeForm,'sources',[])

              sources.forEach(item=>{
                this.modeForm.sources.push({
                  name:item.name,
                  ...item.source
                })
              })
              this.modelLoading = true
              this.modeActive = 0;
              this.viewMultiShow = true;
              this.$store.state.mask = true;
              res.result.forEach(item => {
                item.propertySet = item.propertySet.split(',')
              })
              this.deviceList = res.result
              var devCodeArr=[],proCodeArr=[]
              for(let item of allSources){
                if(item.source.product){
                  if(proCodeArr.includes(item.source.product)){

                  }else{
                    proCodeArr.push(item.source.product)
                    this.devChange(item.source.device)
                  }
                }
                if(item.optimization_result){
                  if(item.optimization_result.product){
                    if(proCodeArr.includes(item.optimization_result.product)){
                    }else{
                      proCodeArr.push(item.optimization_result.product)
                      this.devChange(item.optimization_result.device)
                    }
                  }
                }
                if(item.prediction_result){
                  if(item.prediction_result.product){
                    if(proCodeArr.includes(item.prediction_result.product)){
                    }else{
                      proCodeArr.push(item.prediction_result.product)
                      this.devChange(item.prediction_result.device)
                    }
                  }
                }

              }
            } else {
              this.$message({
                message: `获取企业设备列表失败:${res.message}`,
                type: 'warning'
              });
            }
          })
        } else {
          this.$message({
            message: `获取所属企业失败:${res.message}`,
            type: 'warning'
          });
        }
      })
      this.$set(this.modeForm,'control_data',this.modeForm.control_data)
      setTimeout(()=>{
        this.modeForm.output_data.forEach(item=>{
          this.setNameZh(item,null,true)
        })
        this.modelLoading = false
        this.$forceUpdate()
      },1200)
    },
    escapeResultHtml(value){
      return String(value === null || value === undefined ? '-' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    formatResultObject(obj){
      if(obj === null || obj === undefined){
        return '<div class="result-object-empty">-</div>'
      }
      if(typeof obj === 'object'){
        var keys = Object.keys(obj)
        if(!keys.length) return '<div class="result-object-empty">-</div>'
        return keys.map(key => {
          var label = this.escapeResultHtml(this.getNameByTarget(key))
          var value = this.escapeResultHtml(this.getValueByTarget(obj[key],key))
          var unit = this.escapeResultHtml(this.getUnitByTarget(key))
          return `<div class="result-object-row">
            <span class="result-object-label">${label}</span>
            <strong class="result-object-value">${value}<em>${unit}</em></strong>
          </div>`
        }).join('')
      }
      return `<strong class="result-object-value single">${this.escapeResultHtml(obj)}</strong>`
    },
    // 根据target获取设备/属性名
    async getTargetName(key){
      // 兼容输入/控制数据的 __OAO__ 与输出数据的 __BOB__ 两种标识符。
      var targetKey = String(key || "")
      var separator = targetKey.includes("__BOB__") ? "__BOB__" : "__OAO__"
      var codes = targetKey.split(separator),
      dev = this.deviceList.find(item=>item.code == codes[0])
      if(!dev) return
      this.get("/ProductFeature/getByDeviceCode",{code:codes[0]}).then(res=>{
        if(res.success){
          let data = JSON.parse(res.result).properties;
          let propertie = data.find(item=>item.identifier==codes[1])
          if(!propertie) return
          var newNameObj = {
            target:key,
            name:`${dev.name}/${propertie.name}`,
            unit:propertie.dataType.specs.unit,
            type:propertie.dataType.type,
          }
          if(newNameObj.type=="bool"||newNameObj.type=='enum'){
            newNameObj.specs = propertie.dataType.specs
          }else if(newNameObj.type=="float"||newNameObj.type=='int'||newNameObj.type=='double'){
            var step = String(propertie.dataType.specs.step);
            if(!step.includes('.')){
              newNameObj.decimal = 0
            }else{
              newNameObj.decimal = step.split('.')[1].length;
            }
            newNameObj.step = propertie.dataType.specs.step
          }
          this.targetNameArr.push(newNameObj)
        }else{
          this.$message({
            message:"获取设备属性失败："+res.message,
            type:"warning"
          })
        }

      })

    },
    // 查看结果
    MultiModelResult(obj){
      if(this.$store.state.isLook){return}
      if(!obj || !obj.id){
        this.$message({
          message: '模型ID不存在，无法获取结果',
          type: 'warning'
        });
        return
      }
      if(!obj.lastResult){
        this.$message({
          message: obj.lastError||'暂无结果',
          type: 'warning'
        });
        return
      }
      this.nowObj = this.clone(obj)
      this.modelResult = null

      this.get('/AI2/result',{id:obj.id}).then(res=>{
        if(res.success){
          this.modelResult = res.result || null
          // /AI2/result 返回的 result.data 已经是解析后的 JSON 对象
          this.get('/Company/get?code=' + obj.groupCode).then(res => {
            if(res.success){
              this.get('/Device/getList', {
                companyId: res.result[0].id
              }).then(async res => {
                this.resultShow = true
                this.$store.state.mask = true
                this.deviceList = res.result
                if(this.modelResult.data.result.best){
                  for(let item of Object.keys(this.modelResult.data.result.best.controls)){
                    this.getTargetName(item)
                  }
                  for(let item of Object.keys(this.modelResult.data.result.best.predictions)){
                    this.getTargetName(item)
                  }
                }
                if(this.modelResult.data.result.predictions&&this.modelResult.data.result.predictions.length){
                  for(let item of Object.keys(this.modelResult.data.result.predictions[0].predictions)){
                    var targetObj = this.targetArr.find(key=>key == item)
                    if (!targetObj){
                      this.targetArr.push(item)
                      this.getTargetName(item)
                    }
                    
                    
                  }
                }
              })
            }else{
              this.$message({
                message: `获取所属组织失败：${res.message}`,
                type: 'warning'
              });
            }
          })
          
        }else{
          this.$message({
            message: `获取结果失败：${res.message}`,
            type: 'warning'
          });
        }
      }).catch(()=>{
        this.$message({
          message: '获取结果失败',
          type: 'warning'
        });
      })
    },
    operate(obj, name, i) {
      if (!this.functionSetList.includes('aiEdit') || this.$store.state.isLook) {
        return
      } else if (name == 'train' && (obj.trainStatus == 1 || obj.trainStatus == 2)) {
        return
      } else if ((name == 'enable' || name == 'disable') && obj.trainStatus != 3) {
        return
      }
      name += "Show";
      this.nowObj = obj;
      this.nowIndex = i;
      this[name] = true
      this.$store.state.mask = true
    },

    close(name) {
      if (name == 'result') {
        this.resultShow = false
        this.modelResult = null
        this.$store.state.mask = false
        return
      }
      if (name == 'viewMulti') {
        this.viewMultiShow = false;
        this.viewMode = false;
        this.$store.state.mask = false;
        return;
      }
      if (name == 'add' || name == 'view') {
        this.ruleForm = this.$options.data().ruleForm
        this.$refs.addForm.clearValidate()
        setTimeout(() => {
          this.$refs.addForm.clearValidate(["train", "predict", "trainDevice", "trainProperty", "predictDevice", "predictProperty"])
        })
      }
      name += "Show";
      this[name] = false
      this.$store.state.mask = false
    },
    // 删除模型
    deleteModel() {
      let parm = {
        id: this.nowObj.id
      }
      this.get('/AI2/remove', parm).then((res) => {
        if (res.success) {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getlist();
        } else {
          this.$message({
            message: `删除失败：${res.message}`,
            type: 'warning'
          });
        }
        this.$store.state.mask = false;
        this.deleteShow = false;
      })
    },
    // 训练模型
    train() {
      let parm = {
        id: this.nowObj.id
      }
      this.post('/AI2/train', parm).then((res) => {
        if (res.success) {
          this.$message({
            message: '开始训练',
            type: 'success'
          });
          this.getlist()
        } else {
          this.$message({
            message: `训练失败：${res.message}`,
            type: 'warning'
          });
        }
        this.$store.state.mask = false;
        this.trainShow = false;
      })
    },
    //启用模型
    enable() {
      let parm = {
        id: this.nowObj.id
      }
      this.post('/AI2/enable', parm).then((res) => {
        if (res.success) {
          this.$message({
            message: '启用成功',
            type: 'success'
          });
          this.dataList[this.nowIndex].applyStatus = 1;
        } else {
          this.$message({
            message: `启用失败：${res.message}`,
            type: 'warning'
          });
        }
        this.$store.state.mask = false;
        this.enableShow = false;
      })
    },
    //停用模型
    disable() {
      let parm = {
        id: this.nowObj.id
      }
      this.post('/AI2/disable', parm).then((res) => {
        if (res.success) {
          this.$message({
            message: '停用成功',
            type: 'success'
          });
          this.dataList[this.nowIndex].applyStatus = 0
        } else {
          this.$message({
            message: `停用失败：${res.message}`,
            type: 'warning'
          });
        }
        this.$store.state.mask = false;
        this.disableShow = false;
      })
    },
    setTrainSort(item) {
      if (!item.trainSort) {
        item.trainSort = item.oldTrainSort
      } else if (item.trainSort > 100 || item.trainSort < 0) {
        this.$message({
          type: "warning",
          message: "请输入0-100的数字"
        })
      } else {
        let parm = {
          id: item.id,
          sort: item.trainSort
        }
        this.post("/AI2/updateSort", parm).then(res => {
          if (res.success) {
            this.$message({
              message: `修改成功`,
              type: 'success'
            });
            this.getlist()
          } else {
            this.$message({
              message: `获取列表数据失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      }
    },
    // 修改分页size
    setSize(pageObj) {
      this.pageSize = pageObj.size;
      this.getlist();
    },
    // 修改页数
    setNum(number) {
      this.pageNumber = number;
      this.getlist();
    },
    addModel() {
      this.addShow = true
      this.$store.state.mask = true
    },
    addModel2() {
      // this.orSuperior = {}
      this.deviceList = []
      if (this.orSuperior.type == 3) {
        this.get('/Device/getList', {
          companyId: this.orSuperior.id
        }).then(res => {
          if (res.success) {
            res.result.forEach(item => {
              item.propertySet = item.propertySet.split(',')
            })
            this.deviceList = res.result
          } else {
            this.$message({
              message: `获取企业设备列表失败:${res.message}`,
              type: 'warning'
            });
          }
        })
      }
      this.modeForm = this.$options.data().modeForm
      // this.$refs.addModeForm.clearValidate()
      this.modeActive=0
      this.addModeShow = true
      this.$store.state.mask = true
    },
    headClick(state) {
      this.state = state
      this.pageNumber = 1
      this.dataList = []
      this.getlist()
    },
    modeClick(index) {
      this.modeActive = index
    },
    setTree() {
      this.getTree()
    },
    getTree(type) {
      this.get('/Group/getOrganizationTree').then((res) => {
        if (res.success) {
          this.Tree = res.result;
          this.setOrcode = true;
          this.orCode = this.Tree[0].code
          this.$store.state.treeData = this.Tree
          this.orSuperior = {}
          this.oldorSuperior = this.clone(this.orSuperior)
          this.functionSetList = this.$store.state.treeData[0].functionSet.split(',')
          this.$store.state.expandedArr = []
          this.expanded(this.$store.state.treeData, 1)
          if (type == 'a') {
            this.roleId = this.$store.state.treeData[0].roleId
            this.getlist();
            this.VerifyArr = localStorage.getItem('verifyCodeModule').split(',').map(Number)
          }
          this.orSuperiorData = [] //初始化树
          for (let obj of res.result) {
            if (obj.roleId == this.roleId) { //获取当前角色下树数据
              obj = this.clone(obj)
              this.orSuperiorData.push(obj)
              return
            }
          }
        }
      })
    },
    setOrId(node) {
      this.roleId = node[0].roleId
      this.orSuperiorData = []
      for (let obj of this.$store.state.treeData) {
        if (node[0].roleId == obj.roleId) { //获取当前角色下的树数据
          obj = this.clone(obj)
          this.orSuperiorData.push(obj)
        }
      }
      this.orCode = node[0].code;
      this.functionSetList = node[1]
      this.orSuperior=this.clone(node[0]);
      this.oldorSuperior = this.clone(this.orSuperior)
      this.setCount = true
      this.pageNumber = 1
      this.getlist()
    },
    // 获取列表
    getlist() {
      let parm = {
        pageNumber: this.pageNumber,
        length: this.pageSize,
        code: this.orCode
      }
      let url = this.state == 2 ? '/AI2/query' : '/AI2/queryTask'
      this.get(url, parm).then((res) => {
        if (res.success) {
          this.dataList = res.result.data;
          this.dataList.forEach(item => {
            item.oldTrainSort = item.trainSort
          })
          if (this.setCount) {
            this.totalCount = res.result.totalCount;
            this.setCount = false
          }
        } else {
          this.$message({
            message: `获取列表数据失败：${res.message}`,
            type: 'warning'
          });
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
img.notes{
    position: relative;
    left: 8px;
    top: 6px;
}
.color-green {
  color: #0c3;
}

.color-green2 {
  color: #91de94;
}

.color-red {
  color: red !important;
}

.extend-box {
  max-height: 220px;
  overflow: auto;
}

.max-h-300 {
  max-height: 300px;
  width: 100%;
  overflow: auto;
}
#IntelligentPrediction .max-h-400{
  max-height: 400px;
  width: 100%;
  overflow: auto;
  .w-20.el-form-item {
    width: 120px !important;
  }
}
#IntelligentPrediction {
  .train-config {
    box-sizing: border-box;
    height: calc(70vh - 185px);
    margin-top: 0 !important;
    overflow: auto;
    padding: 20px 18px 28px;
    border: 1px solid #d8e2ef;
    border-radius: 3px;
    background: #fff;

    .config-title {
      padding-left: 12px;
      border-left: 3px solid #13a8d4;

      h4 {
        margin: 0;
        color: #001f44;
        font-size: 16px;
        line-height: 22px;
        font-weight: 600;
      }

      p {
        margin: 4px 0 0;
        color: #536b89;
        font-size: 12px;
        line-height: 18px;
      }
    }

    .config-section {
      margin-top: 18px;
      padding-top: 18px;
      border-top: 1px solid #d8e2ef;

      h5 {
        margin: 0;
        color: #001f44;
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
      }

      >p {
        margin: 4px 0 14px;
        color: #536b89;
        font-size: 12px;
        line-height: 18px;
      }
    }

    .config-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      column-gap: 14px;
      row-gap: 8px;
    }

    .config-item.el-form-item {
      width: 100% !important;
      margin-bottom: 8px !important;
    }

    .config-switches {
      display: flex;
      align-items: center;
      gap: 28px;
      margin-top: 26px;
      padding: 18px 14px;
      border: 1px solid #d8e2ef;
      background: #f7fbff;
    }

    .config-switch-item.el-form-item {
      width: auto !important;
      margin-bottom: 0 !important;

      &>>>.el-form-item__content {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #001f44;
        font-size: 12px;
        line-height: 22px !important;
      }
    }
  }

  .train-box {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    &.border{
      padding-top: 15px;
      border-top: 1px solid #eee;
    }
    &>>>.el-input__icon {
      line-height: 34px;
    }

    &.m-b-0>>>.el-form-item {
      margin-bottom: 0 !important;
    }

    .flex-form-item {
      width: 180px !important;
      margin-right: 10px;
      &.w-300{
        width: 250px !important;
      }
    }

    .trainSort-box {
      margin-top: -40px;
    }

    &.m-b-10 {
      margin-bottom: 10px;
    }

    &.output-train-box {
      align-items: flex-start;
      gap: 10px;
      margin-bottom: 15px;
    }

    .switch-form-item {
      width: 120px !important;
      margin-right: 0;
    }

    .delAttr {
      float: right;
      color: #5087e4;
      cursor: pointer;
    }
  }
}

.add-train {
  color: #5087e4;
  cursor: pointer;
  float: left;
}

.disabled3 {
  background-color: #F5F7FA !important;
  color: #C0C4CC !important;
  cursor: not-allowed;
}

.or-Superior {
  height: 34px;
  line-height: 34px;
  border-radius: 5px;
  border: 1px solid #e5e5e5;
  padding: 0 10px;
  position: relative;
  box-sizing: border-box;
  top: 40px;
  margin-bottom: 40px;

  i {
    float: right;
  }

  img {
    width: 22px;
    margin-top: 6px;
  }

  img.tree-icon {
    width: 16px !important;
    position: relative;
    top: 3px;
    left: -2px;
  }

  .select-box {
    width: 100%;
    position: absolute;
    left: -1px;
    top: 32px;
    border: 1px solid #e5e5e5;
    max-height: 315px;
    overflow: auto;
    /* width: 370px; */
    border-radius: 5px;
    z-index: 99;
    background: #fff;
  }

  .p-a-l-10 {
    position: absolute;
    left: 10px;
  }

}

.popup>div {
  position: fixed;
  top: 10%;
  left: 50%;
  padding: 0 28px;
  box-sizing: border-box;
  margin-left: -406px;
  width: 578px;
  background-color: #fff;
  z-index: 9999;
  padding-bottom: 30px;
}

.popup-title {
  font-size: 16px;
  line-height: 64px;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 22px;
  text-align: left;
}

.popup-lab {
  font-size: 14px;
  line-height: 30px;
  margin-bottom: 14px !important;
  margin-top: 22px !important;

  & .m-t-0 {
    margin-top: 0 !important;
  }
}

.popup-enable .popup-title {
  margin-bottom: 12px;
}

.popup-add {
  max-height: 762px !important;
  top: calc(50% - 380px) !important;
  padding-bottom: 80px !important;
}

.mode2 {
  width: 1014px !important;
  height: 75vh;
  margin-left: -504px !important;
}

.popup-enable {
  height: 284px;
  position: relative;
}

.btn-box {
  position: absolute;
  text-align: center;
  bottom: 36px;
  width: 100%;
  left: 0;
}

.btn-box .el-button {
  padding: 0 34px !important;
  line-height: 34px !important;
  margin: 0 20px;
}

i.close {
  font-size: 20px;
  float: right;
  margin-top: 24px;
}

.organize {
  position: absolute;
  top: 36px;
  bottom: 0;
}

.list-box {
  position: absolute;
  top: 36px;
  left: 328px;
  right: 0;
  bottom: 0;

  .list-top {
    margin: 0px 16px 15px 16px;
    padding-top: 24px;
  }
}

.no-flexid.tabs-box2 {
  margin-bottom: 10px;
  display: flex;
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: 1px solid #d2d2d2;
  align-items: center;
  width: 664px;
  span {
    float: left;
    display: inline-block;
    width: 110px;
    font-size: 14px;
    line-height: 40px;
    border-left: 1px solid #e2e2e2;
    cursor: pointer;
  }

  .active {
    background: #5087e4;
    color: #fff;

    span {
      border: 0;
    }
  }
}

.tabs-box {
  float: left;
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: 1px solid #d2d2d2;
  position: absolute;
  top: -43px;

  div {
    float: left;
    padding: 9px 0;
  }

  span {
    float: left;
    display: inline-block;
    width: 160px;
    font-size: 14px;
    line-height: 22px;
    border-left: 1px solid #e2e2e2;
    cursor: pointer;
  }

  .active {
    background: #5087e4;
    color: #fff;

    span {
      border: 0;
    }
  }
}

.bg {
  width: 100%;
  margin-top: 42px;
  height: 90%;
}

.add-btn {
  float: left;
  line-height: 32px !important;
  padding: 0 15px !important;
}

.search {
  float: right;
  width: 388px;
  margin-right: 10px;
}

.search-btn {
  float: right;
}

.list-title,
.list-details {
  display: flex;
  justify-content: space-around;
  line-height: 44px;
  font-size: 14px;
  color: #636363;
}

.list-title {
  background: #eeeeee;
}

.list-title li,
.list-details li {
  width: 200px;
  margin: 0 5px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.list-details {
  border-top: 1px solid #f2f2f2;
}

.operate span {
  margin: 0 4px;
  color: #5087e4;
}

.w-18 {
  width: 18% !important;
}

.w-90 {
  width: 90px !important;
  margin-right: 15px !important;
}

.min-140 {
  min-width: 200px;
}

.min-44 {
  min-width: 44px;
}

.min-60 {
  min-width: 60px;
}

.scroll {
  overflow: auto;
  width: 97.6%;
  max-height: 88% !important;
  height: 88%;
  margin: 0 16px;
  box-sizing: border-box;
  border: 1px solid #f2f2f2;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.bg.t-0 {
  margin-top: 0 !important;
}

.tabs-box>div:first-child span {
  border: none;
}

.company-list {
  overflow: hidden;
  margin-bottom: 32px;
  height: 90%;
}

/* 查看模型只读模式 */
.readonlyMode .el-input,
.readonlyMode .el-select,
.readonlyMode .el-radio-group,
.readonlyMode .el-switch,
.readonlyMode .el-textarea {
  pointer-events: none;
}
.readonlyMode .delAttr {
  display:none !important;
}

.result-popup {
  width: 1120px !important;
  margin-left: -560px !important;
  height: 88vh !important;
  max-height: 88vh !important;
  top: calc(50% - 44vh) !important;
  padding: 0 28px 78px !important;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(31, 56, 88, 0.16);
  border-radius: 4px;
}

.result-popup .popup-title {
  margin-bottom: 0;
  height: 64px;
  line-height: 64px;
  font-size: 17px;
  font-weight: 600;
  color: #17365d;
}

.result-popup .result-body {
  max-height: calc(88vh - 145px);
  overflow-y: auto;
  padding: 20px 0 24px;
  box-sizing: border-box;
}

.result-popup .el-table th:hover, .result-popup .el-table tr:hover{
  background-color: #fff !important;
}

// .result-popup .result-body::-webkit-scrollbar {
  // width: 7px;
// }
// .result-popup .result-body::-webkit-scrollbar-thumb {
  // background: #c8d5e6;
  // border-radius: 8px;
// }
// .result-popup .result-body::-webkit-scrollbar-track {
  // background: #f5f8fc;
// }

.result-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 14px;
  background: #f7faff;
  border: 1px solid #dce7f4;
  border-radius: 3px;
  margin-bottom: 24px;
}

.result-meta-card {
  min-height: 62px;
  padding: 10px 14px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #e4ebf4;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.result-meta-label {
  display: block;
  margin-bottom: 5px;
  color: #8190a5;
  font-size: 12px;
  line-height: 18px;
}

.result-meta-value {
  display: block;
  color: #253b56;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  word-break: break-all;
}

.result-meta-value.result-direction {
  color: #3d6fa8;
}

.result-message {
  grid-column: 1 / -1;
  padding: 10px 14px;
  background: #fff;
  color: #42566f;
  line-height: 22px;
}

.result-message strong {
  font-size: 13px;
  font-weight: 500;
  word-break: break-all;
}

.result-success {
  color: #18a058 !important;
}
.result-error {
  color: #e05252 !important;
}

.result-section-title {
  position: relative;
  margin: 22px 0 12px;
  padding-left: 11px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #203b5b;
}
/*
.result-section-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 3px;
  width: 3px;
  height: 18px;
  border-radius: 2px;
  background: #5087e4;
}
*/ 
.result-table {
  width: 100%;
  margin-bottom: 22px;
  border-color: #dfe7f1 !important;
}

.result-table >>> .el-table__header-wrapper th {
  height: 46px;
  background: #eee !important;
  color: #50657e;
  font-size: 13px;
  font-weight: 600;
  border-color: #dfe7f1 !important;
}

.result-table >>> .el-table__body-wrapper td {
  min-height: 52px;
  color: #40556d;
  font-size: 13px;
  border-color: #e3eaf3 !important;
}

.result-table >>> .el-table__row:hover > td {
  background: #ffffff !important;
}

.result-table >>> .cell {
  line-height: 22px;
  padding: 7px 10px;
}


.result-object-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 14px;
  min-height: 30px;
  padding: 4px 0;
  border-bottom: 1px dashed #e3e9f1;
}

.result-object-row:last-child {
  border-bottom: 0;
}
.result-object-empty {
  color: #a0aab7;
  text-align: center;
}

.best-result-table {
  border: 1px solid #cfddec !important;
  box-shadow: 0 2px 8px rgba(50, 83, 120, 0.06);
}

.best-result-table >>> .el-table__header-wrapper th {
  background: #eaf3fc !important;
  color: #31577e;
}

.best-result-table >>> .el-table__body tr:first-child td {
  background: #fafdff;
}

.improvement-value {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 48px;
}

.improvement-value strong {
  color: #1677c8;
  font-size: 22px;
  line-height: 28px;
  font-weight: 700;
}

.improvement-value span {
  color: #7a8ca1;
  font-size: 11px;
  line-height: 18px;
}

.constraint-table >>> .el-table__body td {
  vertical-align: middle;
}

.constraint-name {
  color: #2f4965;
  font-weight: 600;
}

.constraint-compare {
  color: #546b84;
  font-size: 14px;
}

.constraint-value {
  color: #1f3f60;
  font-size: 16px;
  font-weight: 700;
}

.constraint-unit {
  margin-left: 4px;
  color: #8291a4;
  font-size: 11px;
}

.safety-value {
  color: #526981;
  font-size: 14px;
}

.result-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 66px;
  height: 28px;
  padding: 0 9px;
  box-sizing: border-box;
  border-radius: 14px;
  font-size: 12px;
  font-weight: 600;
}

.result-badge i {
  margin-right: 4px;
  font-size: 13px;
}

.result-badge-success {
  color: #1d9a5a;
  background: #edf9f2;
  border: 1px solid #c7ecd7;
}

.result-badge-error {
  color: #d94a4a;
  background: #fff0f0;
  border: 1px solid #f2caca;
}

.alternative-table {
  margin-top: 4px;
}

.count-value {
  display: inline-block;
  min-width: 28px;
  color: #1e3856;
  font-size: 13px;
  line-height: 26px;
  font-weight: 500;
}

.result-warning {
  padding: 12px 15px;
  background: #fff8ec;
  border: 1px solid #f3dfb8;
  border-left: 3px solid #e6a23c;
  color: #9a6a1a;
  margin-top: 18px;
  border-radius: 3px;
  text-align: left;
}
.result-warning p {
  font-size: 13px;
  margin: 6px 0;
  line-height: 24px;
}

.result-empty {
  padding: 60px 0;
  text-align: center;
  color: #9099a8;
  font-size: 14px;
}

.result-popup .btn-box {
  bottom: 20px;
  height: 40px;
}

.result-popup .btn-box .el-button {
  min-width: 98px;
  border-radius: 3px;
}

@media screen and (max-width: 1200px) {
  .result-popup {
    width: 92% !important;
    margin-left: -46% !important;
  }
  .result-meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 700px) {
  .result-meta {
    grid-template-columns: 1fr;
  }
  .result-message {
    grid-column: auto;
  }
}
</style>
<!-- 修改默认样式 -->
<style lang="scss">
.result-object-label {
  flex: 0 1 52%;
  /* color: #74869b; */
  color: #1e3856;
  font-size: 13px;
  line-height: 22px;
  word-break: break-all;
}

.result-object-value {
  padding-left: 4px;
  flex: 0 0 auto;
  /* color: #1e3856; */
  color: #4387f7;
  font-size: 16px !important;
  line-height: 24px;
  font-weight: bold;
  text-align: right;
  word-break: break-all;
}

.result-object-value em {
  margin-left: 4px;
  color: #7f8fa3;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
}

.result-object-value.single {
  display: block;
  text-align: left;
}

#IntelligentPrediction .block-div {
  .el-radio-group,.el-select{
    width: 100%;
  }
  
}

#IntelligentPrediction .tree-box .el-tree-node__content {
  padding-left: 14px !important;
}

#IntelligentPrediction .tree .el-tree-node {
  width: 263px;
  padding-right: 30px;
  box-sizing: border-box;
}

#userList .tree-box.left-17 .el-tree-node__children {
  position: relative;
  left: 17px !important;
}

#IntelligentPrediction .popup .el-input__inner {
  line-height: 34px !important;
  height: 34px !important;
  padding: 0 10px !important;
}

#IntelligentPrediction .popup .el-form-item {
  width: 100% !important;
  margin-bottom: 12px !important;
}

#IntelligentPrediction .popup .el-form-item.w-50 {
  width: 48% !important;
}

#IntelligentPrediction .popup .el-form-item__label {
  padding: 0 !important;
  left: 9px;
}

#IntelligentPrediction .popup .el-form-item__content {
  line-height: 34px !important;
}

#IntelligentPrediction .search .el-input__inner {
  line-height: 34px !important;
  height: 34px !important;
  padding: 0 10px !important;
}

#IntelligentPrediction .search .el-icon-search {
  line-height: 34px !important;
}

#IntelligentPrediction .p-l-0 .el-tree-node {
  padding-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/IntelligentPrediction/model.vue